/* global __app_id, __initial_auth_token, __firebase_config */
import React, { useState, useEffect } from 'react';
import { 
  PlayCircle, CheckCircle, Activity, ChevronRight, ArrowLeft, Check,
  HeartPulse, Info, Lock, X, Users, Mail, User, Calendar, TrendingUp,
  FileText, Shield, Download, Globe, Star, Flame, Clock, MessageCircle,
  Lightbulb, Award, ArrowRight, BrainCircuit, ListVideo, CloudRain, 
  Wind, Sun, Briefcase, Accessibility, Timer, Trophy, Map, MapPin, BarChart3,
  Trash2, Smile, Dumbbell, Move, Focus
} from 'lucide-react';

import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, signInWithCustomToken, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, addDoc, getDocs, updateDoc, doc, serverTimestamp, deleteDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCnx1NTPxaqKznlI-9YXe5YMxuxJiKPUuI",
  authDomain: "fizyodurak.firebaseapp.com",
  projectId: "fizyodurak",
  storageBucket: "fizyodurak.firebasestorage.app",
  messagingSenderId: "995871173541",
  appId: "1:995871173541:web:b17bdf349df38742b0964c",
  measurementId: "G-3H0GH7RRP8"
};

const finalFirebaseConfig = typeof __firebase_config !== 'undefined' && __firebase_config ? JSON.parse(__firebase_config) : firebaseConfig;
const appId = typeof __app_id !== 'undefined' ? __app_id : 'fizyo-durak-app';

let app, auth, db;
if (finalFirebaseConfig && finalFirebaseConfig.apiKey) {
  app = initializeApp(finalFirebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
}

const CustomConfetti = () => {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    const colors = ['#fce18a', '#ff726d', '#b43f3f', '#f8b400', '#2a9d8f', '#4285F4', '#34A853'];
    const newPieces = Array.from({ length: 150 }).map((_, i) => ({
      id: i, left: Math.random() * 100, animationDelay: Math.random() * 2,
      animationDuration: Math.random() * 3 + 2, color: colors[Math.floor(Math.random() * colors.length)],
      size: Math.random() * 8 + 5, rotation: Math.random() * 360,
    }));
    setPieces(newPieces);
  }, []);
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0 rounded-3xl">
      <style>{`@keyframes custom-confetti-fall { 0% { transform: translateY(-10vh) rotate(0deg); opacity: 1; } 100% { transform: translateY(100vh) rotate(720deg); opacity: 0; } }`}</style>
      {pieces.map((p) => (
        <div key={p.id} className="absolute top-[-10%]" style={{ left: `${p.left}%`, width: `${p.size}px`, height: `${p.size * 1.5}px`, backgroundColor: p.color, animation: `custom-confetti-fall ${p.animationDuration}s linear ${p.animationDelay}s forwards`, transform: `rotate(${p.rotation}deg)`, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }} />
      ))}
    </div>
  );
};

const t = {
  tr: {
    appTitle: "FizyoDurak", welcomeSub: "Beklerken sağlığınıza zaman ayırın.", emailLabel: "E-posta Adresi", emailPlaceholder: "ornek@mail.com",
    loginBtn: "Giriş Yap ve Başla", checking: "Giriş Yapılıyor...", invalidEmail: "Lütfen geçerli bir e-posta girin.",
    footerDesc: "Toplu taşıma duraklarında bekleyen bireylere yönelik, yapay zeka destekli, kişiselleştirilmiş egzersiz platformu.",
    contact: "İletişim", legal: "Yasal", terms: "Kullanım Koşulları", privacy: "Gizlilik Politikası", medWarning: "Tıbbi Uyarı", rights: "© 2026 FizyoDurak. Tüm hakları saklıdır.",
    demoTitle: "Aramıza Hoşgeldiniz!", demoSub: "Size özel bir deneyim için sizi biraz tanıyalım.", ageLabel: "Yaşınız", agePlaceholder: "Örn: 35", genderLabel: "Cinsiyetiniz", next: "Devam Et", saving: "Kaydediliyor...",
    regAs: "Sisteme ", regAs2: " olarak kayıtlısınız.", whereHurts: "Nereniz Ağrıyor?", selectArea: "Bugün rahatlatmak istediğiniz bölgeyi seçin.", exercisesForYou: "Sizin için hazırladığımız özel egzersizler:",
    back: "Geri", vidNotLoaded: "Video Yüklenmedi", painWarning: "Egzersizi yaparken ağrı hissederseniz lütfen bırakın. Hareketleri yavaş yapın.", completeBtn: "Egzersizi Tamamladım",
    congrats: "Tebrikler!", healthStep: "Sağlığınız için harika bir adım attınız.", goHome: "Ana Sayfaya Dön", goHomeTitle: "Ana Sayfaya Dön", adminLogin: "Yönetici Girişi", adminLoginSub: "Lütfen yönetici şifresini giriniz.", password: "Şifre", login: "Giriş Yap",
    wrongPass: "Şifre hatalı. Lütfen tekrar deneyin.", adminPanelTitle: "Kayıtlı Danışanlar", adminPanelSub: "Detaylı analizlerini görmek için bir danışana tıklayın.", totalClients: "Toplam Danışan:",
    downloadExcel: "Tüm Verileri Excel'e İndir", clearDataBtn: "Verileri Temizle", confirmClear: "Tüm verileri silmek istediğinize emin misiniz?", clearing: "Siliniyor...",
    loadingData: "Veriler Yükleniyor...", noExercise: "Henüz egzersiz yapmadı", totalEx: "Toplam Egzersiz:", noClients: "Kayıtlı danışan bulunmuyor.",
    clientList: "Listeye Dön", ageOld: "Yaşında", lastEx: "Son Egzersiz", favArea: "Favori Bölge", favEx: "Favori Egzersiz", exit: "Çıkış", step: "Adım", profileInfo: "Profil & Rozetler",
    totalPoints: "Toplam Puan", currentStreak: "Mevcut Seri", dayStreak: "Gün", badges: "Rozetlerim", locked: "Kilitli", earnedPoints: "Puan Kazandınız!", newBadgeUnlocked: "Yeni Rozet Açıldı:",
    dailyLimit: "Günlük puan sınırına ulaştınız, yarın tekrar bekleriz!", leaderboard: "Liderlik Tablosu", clientsTab: "Danışanlar", leaderboardTab: "Sıralama", heatmapTab: "Ağrı Haritası", pleaseWait: "Lütfen uygulayın", sec: "sn",
    challengeBtn: "WhatsApp'ta Meydan Oku", shareTextPrefix: "FizyoDurak ile duruşumu düzelttim ve +", shareTextSuffix: " Puan kazandım! Sen de duraktaki QR'ı okut, seriye başla! fizyodurak.com", didYouKnow: "Biliyor muydunuz?",
    modeTitle: "Nasıl Devam Edelim?", modeSub: "Size en uygun rotayı seçin.", modeAI: "Yapay Zeka Asistanı", modeAIAux: "Vaktinize ve ortama göre özel öneriler", modeManual: "Kendim Seçeceğim", modeManualAux: "Tüm kütüphaneyi manuel inceleyin",
    aiQ1: "Otobüsün gelmesine ne kadar var?", aiTimeShort: "1-2 Dakika", aiTimeLong: "5+ Dakika",
    aiQ2: "Şu an hava durumu nasıl?", aiWeatherCold: "Soğuk / Rüzgarlı", aiWeatherNormal: "Güneşli / Normal", aiWeatherRain: "Yağmurlu (Dar Alan)",
    aiQ3: "Fiziksel bir kısıtlamanız var mı?", aiConstNone: "Hayır, rahatım", aiConstBag: "Elimde çanta/yük var", aiConstClothes: "Kıyafetim esnemeye uygun değil",
    aiAnalyzing: "Fizyo-Zeka Düşünüyor...", aiAnalyzingSub: "Tüm koşullarınız analiz edilip en verimli çözüm aranıyor...", aiResultsTitle: "Asistan Önerisi", aiResultsSub: "Algoritmanın sizin için seçtiği en iyi eşleşmeler",
    leaderboardTitle: "Liderlik Tablosu", leaderboardSub: "En aktif durakçılar arasında yerini gör!", you: "Sen", points: "Puan",
    mapTitle: "Durak Ağrı Haritası", mapSub: "Hangi durakta hangi ağrılar yaşanıyor?", analyzeBtn: "Analiz Et", changeBtn: "Değiştir", bestMatch: "En İyi Eşleşme", panel: "Panel",
    leaderboardDesc: "En yüksek puandan düşüğe doğru", times: "Kez", days: "Gün", mapReturn: "Haritaya Dön", stationStats: "Sadece bu durağa ait gerçek zamanlı istatistikler.",
    totalEntry: "Toplam Giriş", personSession: "Kişi / Seans", mostSelectedArea: "En Çok Seçilen Bölge", aiReport: "Yapay Zeka Raporu", comparison: "Kıyaslama",
    efficiency: "Verimlilik", cityProposal: "Belediye Önerisi", pilotData: "Pilot Durak Verileri", viewAnalytics: "Giriş / Analizleri Gör", noData: "Veri Yok"
  },
  en: {
    appTitle: "FizyoDurak", welcomeSub: "Take time for your health while waiting.", emailLabel: "Email Address", emailPlaceholder: "example@mail.com",
    loginBtn: "Login & Start", checking: "Logging in...", invalidEmail: "Please enter a valid email address.", footerDesc: "An innovative AI-powered health platform offering personalized exercise videos.",
    contact: "Contact", legal: "Legal", terms: "Terms of Use", privacy: "Privacy Policy", medWarning: "Medical Disclaimer", rights: "© 2026 FizyoDurak. All rights reserved.",
    demoTitle: "Welcome Aboard!", demoSub: "Let's get to know you for a personalized experience.", ageLabel: "Your Age", agePlaceholder: "e.g. 35", genderLabel: "Your Gender", next: "Continue", saving: "Saving...",
    regAs: "Registered as ", regAs2: ".", whereHurts: "Where does it hurt?", selectArea: "Select the area you want to relieve today.", exercisesForYou: "Special exercises prepared for you:",
    back: "Back", vidNotLoaded: "Video Not Loaded", painWarning: "If you feel pain, please stop. Do movements slowly.", completeBtn: "Completed", congrats: "Congratulations!",
    healthStep: "Great step for your health.", goHome: "Return to Home", goHomeTitle: "Return to Home", adminLogin: "Admin Login", adminLoginSub: "Please enter the admin password.", password: "Password", login: "Login", wrongPass: "Incorrect password.",
    adminPanelTitle: "Registered Clients", adminPanelSub: "Click on a client to see analytics.", totalClients: "Total Clients:", downloadExcel: "Download Data as Excel", clearDataBtn: "Clear Data", confirmClear: "Are you sure you want to delete all data?", clearing: "Clearing...",
    loadingData: "Loading Data...",
    noExercise: "No exercises yet", totalEx: "Total Exercises:", noClients: "No clients registered yet.", clientList: "Back to List", ageOld: "Years Old", lastEx: "Last Exercise", favArea: "Favorite Area",
    favEx: "Favorite Exercise", exit: "Exit", step: "Step", profileInfo: "Profile & Badges", totalPoints: "Total Points", currentStreak: "Current Streak", dayStreak: "Days", badges: "My Badges",
    locked: "Locked", earnedPoints: "Points Earned!", newBadgeUnlocked: "New Badge Unlocked:", dailyLimit: "Daily limit reached, see you tomorrow!", leaderboard: "Leaderboard", clientsTab: "Clients",
    leaderboardTab: "Ranking", heatmapTab: "Pain Map", pleaseWait: "Please perform it", sec: "s", challengeBtn: "Challenge on WhatsApp", shareTextPrefix: "I fixed my posture with FizyoDurak and earned +",
    shareTextSuffix: " Points! Scan the QR to start! fizyodurak.com", didYouKnow: "Did you know?",
    modeTitle: "How to Proceed?", modeSub: "Choose your preferred route.", modeAI: "AI Assistant", modeAIAux: "Tailored to your time and environment", modeManual: "Manual Library", modeManualAux: "Browse all exercises manually",
    aiQ1: "How long until the bus arrives?", aiTimeShort: "1-2 Minutes", aiTimeLong: "5+ Minutes",
    aiQ2: "How is the weather?", aiWeatherCold: "Cold / Windy", aiWeatherNormal: "Sunny / Normal", aiWeatherRain: "Rainy (Tight Space)",
    aiQ3: "Any physical constraints?", aiConstNone: "No, I'm free", aiConstBag: "Holding a bag/load", aiConstClothes: "Restrictive clothing",
    aiAnalyzing: "Fizyo-Zeka is Thinking...", aiAnalyzingSub: "Analyzing all conditions for the most efficient solution...", aiResultsTitle: "Assistant Suggestion", aiResultsSub: "Best matches chosen by our algorithm",
    leaderboardTitle: "Leaderboard", leaderboardSub: "See your rank among the most active stoppers!", you: "You", points: "Pts",
    mapTitle: "Station Pain Map", mapSub: "Which pains are experienced at which station?", analyzeBtn: "Analyze", changeBtn: "Change", bestMatch: "Best Match", panel: "Panel",
    leaderboardDesc: "From highest points to lowest", times: "Times", days: "Days", mapReturn: "Back to Map", stationStats: "Real-time statistics exclusive to this station.",
    totalEntry: "Total Entries", personSession: "Persons / Sessions", mostSelectedArea: "Most Selected Area", aiReport: "AI Report", comparison: "Comparison",
    efficiency: "Efficiency", cityProposal: "City Proposal", pilotData: "Pilot Station Data", viewAnalytics: "Enter / View Analytics", noData: "No Data"
  }
};

const areaTranslations = { 'Baş ve Boyun': { tr: 'Baş ve Boyun', en: 'Head and Neck' }, 'Omuz ve Sırt': { tr: 'Omuz ve Sırt', en: 'Shoulders and Back' }, 'Bel': { tr: 'Bel', en: 'Lower Back' }, 'Bacak ve Diz': { tr: 'Bacak ve Diz', en: 'Legs and Knees' } };
const genderOptions = [{ id: 'Kadın', tr: 'Kadın', en: 'Female' }, { id: 'Erkek', tr: 'Erkek', en: 'Male' }, { id: 'Belirtmek İstemiyorum', tr: 'Belirtmek İstemiyorum', en: 'Prefer not to say' }];

const badgeLibrary = {
  ilk_adim: { icon: '🌱', tr: 'İlk Adım', en: 'First Step' }, istikrarli: { icon: '🔥', tr: 'İstikrarlı', en: 'Consistent' },
  bronz: { icon: '🥉', tr: 'Bronz Durakçı', en: 'Bronze Stopper' }, gumus: { icon: '🥈', tr: 'Gümüş Durakçı', en: 'Silver Stopper' },
  altin: { icon: '🥇', tr: 'Altın Durakçı', en: 'Golden Stopper' }, zen: { icon: '🧘‍♂️', tr: 'Zen Ustası', en: 'Zen Master' }
};

const exerciseLibrary = {
  'Baş ve Boyun': [
    { id: 'bb1', title: 'Temel Boyun Germe', titleEn: 'Basic Neck Stretch', duration: '1 Dk', durationEn: '1 Min', description: 'Sağa ve sola nazik esnetme.', descriptionEn: 'Gentle side stretches.', videoUrl: 'https://www.youtube.com/embed/6EZZrpbePK0?', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bb2', title: 'Yarım Daire Çevirme', titleEn: 'Half Circle Roll', duration: '2 Dk', durationEn: '2 Min', description: 'Boyun gerginliğini alır.', descriptionEn: 'Relieves neck tension.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bb3', title: 'Çene İçe Çekme (Retraksiyon)', titleEn: 'Chin Tuck', duration: '1 Dk', durationEn: '1 Min', description: 'Telefon boynunu (text neck) düzeltir.', descriptionEn: 'Fixes text neck posture.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bb4', title: 'İzometrik Boyun İtme', titleEn: 'Isometric Push', duration: '2 Dk', durationEn: '2 Min', description: 'Boyun kaslarını güçlendirir.', descriptionEn: 'Strengthens neck muscles.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'warmup'] },
    { id: 'bb5', title: 'Derin Boyun Masajı', titleEn: 'Deep Neck Massage', duration: '3 Dk', durationEn: '3 Min', description: 'Parmaklarla ense rahatlatma.', descriptionEn: 'Fingertip neck relief.', videoUrl: '', tags: ['long', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'bb6', title: 'Gökyüzü Bakışı', titleEn: 'Sky Look', duration: '1 Dk', durationEn: '1 Min', description: 'Ön boyun kaslarını esnetir.', descriptionEn: 'Stretches front neck muscles.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bb7', title: 'Omuzdan Boyna Çapraz Germe', titleEn: 'Cross Shoulder Stretch', duration: '2 Dk', durationEn: '2 Min', description: 'Trapez kaslarını rahatlatır.', descriptionEn: 'Relaxes trapezius muscles.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'warmup'] },
    { id: 'bb8', title: 'Kedi-Deve Boyun Versiyonu', titleEn: 'Cat-Cow Neck', duration: '3 Dk', durationEn: '3 Min', description: 'Tüm omurga hattını uyarır.', descriptionEn: 'Stimulates spine line.', videoUrl: '', tags: ['long', 'all', 'free', 'no-bend', 'warmup'] },
    { id: 'bb9', title: 'Hızlı Boyun Rahatlatma', titleEn: 'Quick Neck Relief', duration: '1 Dk', durationEn: '1 Min', description: 'Vakit dar olduğunda anlık çözüm.', descriptionEn: 'Instant relief for tight time.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bb-nefes', title: 'Boyun ve Solunum Egzersizi', titleEn: 'Neck & Breathing', duration: '2 Dk', durationEn: '2 Min', description: 'Doğru nefesle boynu gevşetme.', descriptionEn: 'Relax neck with proper breath.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] }
  ],
  'Omuz ve Sırt': [
    { id: 'os1', title: 'Omuz Silkme', titleEn: 'Shoulder Shrug', duration: '1 Dk', durationEn: '1 Min', description: 'Omuzları kulaklara çekip bırakma.', descriptionEn: 'Pull shoulders to ears and drop.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'os2', title: 'Kürek Kemiği Sıkıştırma', titleEn: 'Scapula Squeeze', duration: '2 Dk', durationEn: '2 Min', description: 'Sırt ağrılarını hafifletir.', descriptionEn: 'Alleviates back pain.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'os3', title: 'Geniş Kol Çevirme', titleEn: 'Wide Arm Circles', duration: '3 Dk', durationEn: '3 Min', description: 'Omuz eklemini tam açar.', descriptionEn: 'Opens shoulder joint fully.', videoUrl: '', tags: ['long', 'all', 'free', 'no-bend', 'warmup'] },
    { id: 'os4', title: 'Göğüs Açma Esnemesi', titleEn: 'Chest Opener', duration: '2 Dk', durationEn: '2 Min', description: 'Kamburluğu (Kifoz) önler.', descriptionEn: 'Prevents hunchback (Kyphosis).', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'os5', title: 'Duvar Destekli Esneme', titleEn: 'Wall Stretch', duration: '3 Dk', durationEn: '3 Min', description: 'Sırtı düzleştirir.', descriptionEn: 'Flattens the back.', videoUrl: '', tags: ['long', 'all', 'free', 'no-bend', 'all'] },
    { id: 'os6', title: 'Tek Kol Çapraz Çekme', titleEn: 'Single Arm Cross', duration: '1 Dk', durationEn: '1 Min', description: 'Arka omuzu esnetir.', descriptionEn: 'Stretches rear shoulder.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'os7', title: 'Yukarı Uzanma', titleEn: 'Reach for the Sky', duration: '2 Dk', durationEn: '2 Min', description: 'Tüm üst gövdeyi uzatır.', descriptionEn: 'Elongates full upper body.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'warmup'] },
    { id: 'os8', title: 'Pervane Hareketi', titleEn: 'Propeller Move', duration: '3 Dk', durationEn: '3 Min', description: 'Omurga rotasyonu sağlar.', descriptionEn: 'Provides spine rotation.', videoUrl: '', tags: ['long', 'all', 'free', 'no-bend', 'warmup'] },
    { id: 'os9', title: 'Mini Omuz Rotasyonu', titleEn: 'Mini Shoulder Rotation', duration: '1 Dk', durationEn: '1 Min', description: 'Dar alanda hızlı ısınma.', descriptionEn: 'Quick warmup in tight space.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'os-nefes', title: 'Sırt ve Solunum Egzersizi', titleEn: 'Back & Breathing', duration: '2 Dk', durationEn: '2 Min', description: 'Diyafram nefesiyle sırtı açma.', descriptionEn: 'Open back with diaphragm breath.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] }
  ],
  'Bel': [
    { id: 'b1', title: 'Ayakta Geriye Esneme', titleEn: 'Standing Back Extension', duration: '1 Dk', durationEn: '1 Min', description: 'Fıtık riskini azaltır.', descriptionEn: 'Reduces hernia risk.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'b2', title: 'Pelvik Tilt (Ayakta)', titleEn: 'Standing Pelvic Tilt', duration: '2 Dk', durationEn: '2 Min', description: 'Bel çukurunu dengeler.', descriptionEn: 'Balances lower back curve.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'b3', title: 'Yana Eğilme', titleEn: 'Side Bend', duration: '2 Dk', durationEn: '2 Min', description: 'Yan bel kaslarını uzatır.', descriptionEn: 'Elongates side back muscles.', videoUrl: '', tags: ['short', 'all', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'b4', title: 'Ayakta Gövde Rotasyonu', titleEn: 'Torso Twist', duration: '3 Dk', durationEn: '3 Min', description: 'Bel omurlarını rahatlatır.', descriptionEn: 'Relaxes lumbar vertebrae.', videoUrl: '', tags: ['long', 'all', 'free', 'no-bend', 'warmup'] },
    { id: 'b5', title: 'Yere Doğru Esneme', titleEn: 'Forward Fold', duration: '3 Dk', durationEn: '3 Min', description: 'Tüm arka hattı açar.', descriptionEn: 'Opens full back line.', videoUrl: '', tags: ['long', 'all', 'free', 'free', 'all'] }, 
    { id: 'b6', title: 'Duvar İtme Hareketi', titleEn: 'Wall Push', duration: '2 Dk', durationEn: '2 Min', description: 'Beli sabit tutarak güçlendirme.', descriptionEn: 'Strengthen core keeping back static.', videoUrl: '', tags: ['short', 'all', 'free', 'no-bend', 'warmup'] },
    { id: 'b7', title: 'Hafif Çömelme (Mini Squat)', titleEn: 'Mini Squat', duration: '2 Dk', durationEn: '2 Min', description: 'Bel destekleyici kasları uyarır.', descriptionEn: 'Stimulates back supporting muscles.', videoUrl: '', tags: ['short', 'all', 'one-hand', 'free', 'warmup'] },
    { id: 'b8', title: 'Tek Bacak Üstünde Denge', titleEn: 'Single Leg Balance', duration: '3 Dk', durationEn: '3 Min', description: 'Merkez bölgesini sıkar.', descriptionEn: 'Tightens the core area.', videoUrl: '', tags: ['long', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'b9', title: 'Hızlı Bel Çevirme', titleEn: 'Quick Hip Circle', duration: '1 Dk', durationEn: '1 Min', description: 'Sertliği anında alır.', descriptionEn: 'Instantly removes stiffness.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'b-nefes', title: 'Bel ve Solunum Egzersizi', titleEn: 'Lower Back & Breathing', duration: '2 Dk', durationEn: '2 Min', description: 'Nefesle bel basıncını düşürme.', descriptionEn: 'Reduce back pressure with breath.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] }
  ],
  'Bacak ve Diz': [
    { id: 'bd1', title: 'Diz Çekme (Ayakta)', titleEn: 'High Knee Pull', duration: '2 Dk', durationEn: '2 Min', description: 'Kalça ve bacak kan dolaşımı.', descriptionEn: 'Hip and leg blood circulation.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'warmup'] },
    { id: 'bd2', title: 'Ayak Bileği Çevirme', titleEn: 'Ankle Rotation', duration: '1 Dk', durationEn: '1 Min', description: 'Uzun süre ayakta duranlar için.', descriptionEn: 'For long time standers.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bd3', title: 'Arka Bacak Germe', titleEn: 'Hamstring Stretch', duration: '3 Dk', durationEn: '3 Min', description: 'Bacak arkası sertliğini alır.', descriptionEn: 'Removes back leg stiffness.', videoUrl: '', tags: ['long', 'all', 'free', 'free', 'all'] },
    { id: 'bd4', title: 'Topuk Kaldırma', titleEn: 'Calf Raise', duration: '2 Dk', durationEn: '2 Min', description: 'Alt bacak kaslarını çalıştırır.', descriptionEn: 'Works lower leg muscles.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'bd5', title: 'Dizi Geriye Bükme', titleEn: 'Quad Stretch', duration: '2 Dk', durationEn: '2 Min', description: 'Ön bacak esnetmesi.', descriptionEn: 'Front leg stretch.', videoUrl: '', tags: ['short', 'compact', 'free', 'no-bend', 'all'] },
    { id: 'bd6', title: 'Yana Adım Atma', titleEn: 'Side Step', duration: '3 Dk', durationEn: '3 Min', description: 'İç bacakları uyarır.', descriptionEn: 'Stimulates inner legs.', videoUrl: '', tags: ['long', 'all', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'bd7', title: 'Parmak Ucunda Durma', titleEn: 'Stand On Tiptoe', duration: '1 Dk', durationEn: '1 Min', description: 'Baldır kaslarını (kalf) güçlendiren.', descriptionEn: 'Strengthens the calf muscles.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] },
    { id: 'bd8', title: 'Görünmez Sandalye', titleEn: 'Wall Sit', duration: '3 Dk', durationEn: '3 Min', description: 'Diz çevresini güçlendirir.', descriptionEn: 'Strengthens knee area greatly.', videoUrl: '', tags: ['long', 'compact', 'free', 'free', 'warmup'] },
    { id: 'bd9', title: 'Hızlı Ayak Vurma', titleEn: 'Quick Taps', duration: '1 Dk', durationEn: '1 Min', description: 'Soğukta kan akışını hızlandırır.', descriptionEn: 'Speeds blood flow in cold.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'warmup'] },
    { id: 'bd-nefes', title: 'Bacak ve Solunum Egzersizi', titleEn: 'Legs & Breathing', duration: '2 Dk', durationEn: '2 Min', description: 'Nefes eşliğinde kas gevşetme.', descriptionEn: 'Muscle relaxation with breath.', videoUrl: '', tags: ['short', 'compact', 'one-hand', 'no-bend', 'all'] }
  ]
};

const areaVisuals = { 'Baş ve Boyun': '💆‍♂️', 'Omuz ve Sırt': '🏋️', 'Bel': '🧍‍♂️', 'Bacak ve Diz': '🦵' };

const healthFacts = [
  { tr: "Cep telefonuna bakarken başınızı eğmek, boynunuza 27 kg ekstra yük bindirir.", en: "Tilting your head to look at your phone puts an extra 27 kg of weight on your neck." },
  { tr: "Derin ve doğru bir solunum, stres hormonunu %30 oranında azaltabilir.", en: "Deep and proper breathing can reduce stress hormones by 30%." },
  { tr: "Düzenli esneme hareketleri kaslara giden kan akışını artırarak yorgunluğu anında alır.", en: "Regular stretching increases blood flow to muscles, instantly relieving fatigue." },
  { tr: "Gülümsemek için yüzünüzdeki 17 farklı kas aynı anda çalışır.", en: "It takes 17 different muscles in your face working together to smile." },
  { tr: "Günde en az 2 litre su içmek, eklemlerin kayganlığını sağlar ve ağrıları önler.", en: "Drinking at least 2 liters of water a day lubricates joints and prevents pain." },
  { tr: "Otururken dik durmak, ciğerlerinize giren oksijen kapasitesini %20 artırır.", en: "Sitting up straight increases the oxygen capacity entering your lungs by 20%." },
  { tr: "Masa başında çalışırken ekran göz hizasında olmalıdır, aksi takdirde boyun düzleşmesi başlar.", en: "When working at a desk, the screen should be at eye level to prevent neck flattening." },
  { tr: "İnsan vücudundaki kemiklerin dörtte biri sadece ayaklarda bulunur.", en: "A quarter of all the bones in the human body are located just in the feet." },
  { tr: "Kalbiniz günde yaklaşık 100.000 kez atarak tüm vücuda kan pompalar.", en: "Your heart beats about 100,000 times a day, pumping blood throughout your body." },
  { tr: "İyi bir postür (duruş) sadece fiziksel sağlığı değil, özgüveni de doğrudan artırır.", en: "Good posture directly improves not only physical health but also self-confidence." },
  { tr: "Göz kaslarınız vücudunuzdaki en aktif kaslardır; günde ortalama 100,000 kez hareket ederler.", en: "Your eye muscles are the most active muscles in your body, moving about 100,000 times a day." },
  { tr: "Sabahları uyandığınızda omurga disklerinizdeki sıvı nedeniyle 1-2 cm daha uzun olursunuz.", en: "You are 1-2 cm taller in the morning because the discs in your spine fill with fluid overnight." },
  { tr: "İnsan kemiği, aynı ağırlıktaki çelikten yaklaşık 5 kat daha güçlüdür.", en: "Human bone is about 5 times stronger than steel of the same weight." },
  { tr: "Sadece 10 dakikalık bir yürüyüş bile beynin endorfin salgılamasını tetikler.", en: "Even just a 10-minute walk triggers the brain to release endorphins." },
  { tr: "Kas hücresi lifleri, gözle görülemeyecek kadar ince ama inanılmaz derecede dayanıklıdır.", en: "Muscle cell fibers are thinner than the eye can see but incredibly durable." },
  { tr: "Esnekliği artırmak, ilerleyen yaşlarda düşme ve yaralanma riskini %40'a kadar azaltır.", en: "Increasing flexibility reduces the risk of falls and injuries in older age by up to 40%." },
  { tr: "Kaslarınızı ısıtmadan spor yapmak mikroskobik yırtıklara sebep olabilir.", en: "Exercising without warming up your muscles can cause microscopic tears." },
  { tr: "Beynimiz, vücudumuzdaki toplam oksijen ve kanın %20'sini tek başına tüketir.", en: "Our brain consumes 20% of the body's total oxygen and blood." },
  { tr: "Hareketsiz bir yaşam tarzı, dünya çapında en yaygın 4. ölüm risk faktörüdür.", en: "A sedentary lifestyle is the 4th leading risk factor for global mortality." },
  { tr: "Uyluk kemiği (femur), vücudumuzdaki en uzun ve en güçlü kemiktir.", en: "The thigh bone (femur) is the longest and strongest bone in the human body." },
  { tr: "Kalp kası, vücutta hiç dinlenmeden ömür boyu çalışan tek kastır.", en: "The heart muscle is the only muscle in the body that works a lifetime without resting." },
  { tr: "Egzersiz yapmak sadece kasları değil, beynin hafıza merkezi olan hipokampüsü de büyütür.", en: "Exercise not only builds muscles but also grows the hippocampus, the memory center of the brain." },
  { tr: "Doğru nefes almak, kalp atış hızını saniyeler içinde yavaşlatabilir.", en: "Breathing correctly can slow down your heart rate in seconds." },
  { tr: "Bağırsaklarımız 'ikinci beyin' olarak adlandırılır ve duygu durumumuzu doğrudan etkiler.", en: "The gut is called the 'second brain' and directly affects our mood." },
  { tr: "İnsan vücudunda yaklaşık 600'den fazla iskelet kası bulunmaktadır.", en: "There are over 600 skeletal muscles in the human body." },
  { tr: "Kambur oturmak, midenize baskı yaparak sindirim sisteminizi yavaşlatabilir.", en: "Slouching puts pressure on your stomach and can slow down your digestive system." },
  { tr: "Düzenli kardiyo yapmak, kılcal damar sayısını artırarak vücuda daha çok oksijen taşır.", en: "Regular cardio increases the number of capillaries, carrying more oxygen to the body." },
  { tr: "Kasların iyileşme ve büyüme süreci sadece siz uyurken gerçekleşir.", en: "The process of muscle recovery and growth only happens while you sleep." },
  { tr: "Ayak tabanında 7000'den fazla sinir ucu bulunur, bu yüzden ayak masajı tüm bedeni rahatlatır.", en: "There are over 7000 nerve endings in the sole of the foot, which is why a foot massage relaxes the whole body." },
  { tr: "Susuz kalmak (%2 civarında), fiziksel performansı ve konsantrasyonu hızla düşürür.", en: "Dehydration (around 2%) rapidly drops physical performance and concentration." },
  { tr: "Omurgamızda 33 adet omur (vertebra) kemiği bulunur ve hepsi birbiriyle bağlantılıdır.", en: "Our spine has 33 vertebrae bones, all interconnected." },
  { tr: "Gülmek, bağışıklık sistemini güçlendiren antikorların üretimini artırır.", en: "Laughing increases the production of antibodies that strengthen the immune system." },
  { tr: "Plank gibi izometrik (sabit) egzersizler, merkez (core) kaslarınızı derinden güçlendirir.", en: "Isometric exercises like planks deeply strengthen your core muscles." },
  { tr: "Uzun süre bacak bacak üstüne atmak, pelvik bölgenin dengesini bozabilir.", en: "Crossing your legs for long periods can disrupt the balance of your pelvic region." },
  { tr: "İskelet sistemimiz ortalama her 10 yılda bir kendini tamamen yeniler.", en: "Our skeletal system completely renews itself roughly every 10 years." },
  { tr: "Yoga ve meditasyon, hücre yaşlanmasını yavaşlatarak biyolojik yaşı genç tutar.", en: "Yoga and meditation slow down cellular aging, keeping your biological age young." },
  { tr: "Ekran parlaklığını kısmak, yatmadan önce melatonin salgılanmasını kolaylaştırır.", en: "Dimming screen brightness makes it easier to release melatonin before bed." },
  { tr: "Sırt çantanızı tek omuzda taşımak omurga eğriliğine (skolyoz) zemin hazırlar.", en: "Carrying your backpack on one shoulder paves the way for spine curvature (scoliosis)." },
  { tr: "Vücudumuzdaki en küçük kemik, orta kulağımızda bulunan üzengi kemiğidir.", en: "The smallest bone in our body is the stapes bone located in the middle ear." },
  { tr: "Esneme hareketleri, kas spazmlarını ve kramplarını önlemenin en doğal yoludur.", en: "Stretching is the most natural way to prevent muscle spasms and cramps." },
  { tr: "Müzik dinleyerek egzersiz yapmak, dayanıklılığı %15 oranında artırabilir.", en: "Exercising while listening to music can increase endurance by 15%." },
  { tr: "Çene kası (Masseter), boyutuna oranla insan vücudundaki en güçlü kastır.", en: "The jaw muscle (Masseter) is the strongest muscle in the human body relative to its size." },
  { tr: "Sağlıklı bir uyku, gün içindeki eklem ağrılarını onarmanın anahtarıdır.", en: "A healthy sleep is the key to repairing joint pains during the day." },
  { tr: "İnsan derisi her ay tamamen dökülür ve yenilenir; ömür boyu 35 kg deri dökeriz.", en: "Human skin completely sheds and renews every month; we shed 35 kg of skin in a lifetime." },
  { tr: "Soğuk duş almak, kan dolaşımını hızlandırır ve kas ağrılarını hafifletir.", en: "Taking a cold shower speeds up blood circulation and relieves muscle pain." },
  { tr: "Kollarımızı iki yana açtığımızda oluşan uzunluk, yaklaşık olarak boyumuza eşittir.", en: "The length formed when we spread our arms wide is approximately equal to our height." },
  { tr: "Terlemek, vücut ısısını dengelemenin yanı sıra ciltteki toksinleri de uzaklaştırır.", en: "Sweating not only balances body temperature but also removes toxins from the skin." },
  { tr: "Parmak izi gibi, her insanın dil izi de tamamen kendine özgüdür.", en: "Like fingerprints, every person's tongue print is completely unique." },
  { tr: "Sadece 5 dakikalık derin diyafram nefesi, tansiyonu normale döndürmeye yardımcıdır.", en: "Just 5 minutes of deep diaphragmatic breathing helps normalize blood pressure." },
  { tr: "Beyin, vücut ağırlığımızın sadece %2'si kadardır ama harcanan enerjinin büyük kısmını çeker.", en: "The brain is only 2% of our body weight but draws a major part of the energy spent." },
  { tr: "Kıkırdak dokusunda kan damarı bulunmaz, besinleri çevresindeki eklem sıvısından alır.", en: "Cartilage tissue has no blood vessels; it gets nutrients from surrounding joint fluid." },
  { tr: "Ergonomik bir koltukta oturmak, bel fıtığı riskini %60 oranında azaltabilir.", en: "Sitting in an ergonomic chair can reduce the risk of a herniated disc by 60%." },
  { tr: "İnsanlar sabah saatlerinde, akşam saatlerine göre ağrıya daha az duyarlıdır.", en: "Humans are less sensitive to pain in the morning compared to the evening." },
  { tr: "Ayak parmaklarımız, yürürken vücut ağırlığımızı dengede tutmamızı sağlayan en önemli uzuvlardır.", en: "Our toes are the most important limbs that keep our body weight balanced while walking." },
  { tr: "Ağlamak, omuz ve göğüs bölgesindeki kasların gevşemesine yardımcı olur.", en: "Crying helps relax the muscles in the shoulder and chest areas." },
  { tr: "Her bir adım attığımızda vücudumuzdaki 200'e yakın kas aynı anda devreye girer.", en: "Every time we take a step, nearly 200 muscles in our body are activated at once." },
  { tr: "Boyun kaslarını esnetmek, gerilim tipi baş ağrılarını bıçak gibi kesebilir.", en: "Stretching neck muscles can cut tension-type headaches like a knife." },
  { tr: "Bir insan ortalama ömrü boyunca dünyayı 3 kez dolaşacak kadar yürür.", en: "An average person walks enough to circle the Earth 3 times in their lifetime." },
  { tr: "Sabah güneşini görmek, vücudun biyolojik saatini (sirkadiyen ritim) düzenler.", en: "Seeing the morning sun regulates the body's biological clock (circadian rhythm)." },
  { tr: "Doğru yastık seçimi, boyun düzleşmesi problemini başlamadan durdurabilir.", en: "Choosing the right pillow can stop neck flattening before it starts." },
  { tr: "Hızlı tempolu yürüyüş, kalbi korumanın en risksiz ve doğal yöntemidir.", en: "Brisk walking is the safest and most natural way to protect the heart." },
  { tr: "Göz kırpmak, gözyaşı tabakasını yenileyerek gözün kurumasını ve enfeksiyon kapmasını önler.", en: "Blinking prevents eye dryness and infection by renewing the tear layer." },
  { tr: "Dudaklardaki sinir uçları, parmak uçlarımızdan yüzlerce kat daha hassastır.", en: "Nerve endings in the lips are hundreds of times more sensitive than our fingertips." },
  { tr: "Esneyerek uyanmak (pandikülasyon), beyne ve kaslara sabahın ilk sinyalini gönderir.", en: "Waking up stretching (pandiculation) sends the first morning signal to the brain and muscles." },
  { tr: "Günde 8 saatten fazla oturmak, sigara içmek kadar tehlikeli sağlık riskleri yaratır.", en: "Sitting more than 8 hours a day creates health risks as dangerous as smoking." },
  { tr: "Baldır kaslarımız, bacaklardaki kanı kalbe geri pompaladığı için 'ikinci kalp' olarak bilinir.", en: "Our calf muscles are known as the 'second heart' because they pump blood from legs back to the heart." },
  { tr: "İnsan kemikleri gelişimini ortalama 25 yaşına kadar sürdürür.", en: "Human bones continue to develop until an average age of 25." },
  { tr: "C vitamini almak sadece bağışıklığı değil, kaslardaki kollajen sentezini de destekler.", en: "Taking Vitamin C supports not only immunity but also collagen synthesis in muscles." },
  { tr: "Aşil tendonu, vücudumuzdaki en kalın ve koptuğunda iyileşmesi en zor tendondur.", en: "The Achilles tendon is the thickest tendon in our body and the hardest to heal if torn." },
  { tr: "Kısa süreli uyuklamalar (power nap), hafızayı tazelemek için bir fincan kahveden daha etkilidir.", en: "Short power naps are more effective than a cup of coffee for refreshing memory." },
  { tr: "Omurganın 'S' şeklindeki eğrisi, yürürken oluşan sarsıntıları yaylanarak emmesini sağlar.", en: "The 'S' shape curve of the spine allows it to spring and absorb shocks while walking." },
  { tr: "Sürekli strese maruz kalmak, omuz ve sırt kaslarının kronik olarak kasılmasına neden olur.", en: "Being constantly exposed to stress causes shoulder and back muscles to contract chronically." },
  { tr: "Masa başında her 45 dakikada bir ayağa kalkmak, kan pıhtılaşması riskini önler.", en: "Standing up every 45 minutes at the desk prevents the risk of blood clots." },
  { tr: "Spor sonrası kas ağrısı (DOMS), kasların güçlenerek yeniden inşa edildiğinin bir işaretidir.", en: "Post-workout muscle soreness (DOMS) is a sign that muscles are rebuilding stronger." },
  { tr: "Doğru yapılan bir squat egzersizi, bacaklar kadar karın kaslarını da (core) çalıştırır.", en: "A properly done squat exercise works the core muscles as much as the legs." },
  { tr: "Gözlerimiz kapalıyken bile dengede durabilmemizi sağlayan sistem iç kulağımızdadır.", en: "The system that allows us to balance even with our eyes closed is in our inner ear." },
  { tr: "Tırnaklar kemik değil, saçlarımız gibi 'keratin' adı verilen sertleşmiş proteinlerden oluşur.", en: "Nails are not bones; like our hair, they consist of hardened proteins called 'keratin'." },
  { tr: "Kas kütleniz ne kadar yüksekse, dinlenirken yaktığınız kalori miktarı da o kadar fazla olur.", en: "The higher your muscle mass, the more calories you burn while resting." },
  { tr: "Hıçkırık, genellikle diyafram kasının ani ve istemsiz olarak kasılmasından kaynaklanır.", en: "Hiccups are usually caused by a sudden, involuntary contraction of the diaphragm muscle." },
  { tr: "Beynimizin %73'ü sudur, bu yüzden susuzluk doğrudan odaklanma problemi yaratır.", en: "73% of our brain is water, which is why dehydration directly causes focus problems." },
  { tr: "İskelet kasları, vücut ısımızı dengede tutmak için titreyerek ısı üretirler.", en: "Skeletal muscles produce heat by shivering to keep our body temperature balanced." },
  { tr: "Esnemek, beyni soğutmak ve kandaki oksijen miktarını artırmak için yapılan bir reflekstir.", en: "Yawning is a reflex done to cool the brain and increase oxygen levels in the blood." },
  { tr: "Bileklerimizdeki bağlar, fare ve klavye kullanırken sürekli tekrarlayan zorlanmalara maruz kalır.", en: "The ligaments in our wrists are exposed to repetitive strain while using a mouse and keyboard." },
  { tr: "Kahkaha atmak, karın kaslarını uyararak tıpkı hafif bir mekik çekmiş etkisi yaratır.", en: "Laughing stimulates abdominal muscles, creating an effect similar to doing mild crunches." },
  { tr: "Yüksek topuklu ayakkabı giymek, vücudun ağırlık merkezini öne kaydırarak bel ağrısına yol açar.", en: "Wearing high heels shifts the body's center of gravity forward, leading to lower back pain." },
  { tr: "Yüzümüzdeki mimik kasları doğrudan kemiklere değil, deriye yapışıktır.", en: "Facial expression muscles are attached directly to the skin, not bones." },
  { tr: "Ayak parmak uçlarında yükselmek, baldır kaslarını hızla çalıştıran mükemmel bir durak egzersizidir.", en: "Rising on tiptoes is an excellent station exercise that quickly works calf muscles." },
  { tr: "Vücudumuzdaki demir miktarı, 7-8 cm uzunluğunda küçük bir çivi yapacak kadardır.", en: "The amount of iron in our body is enough to make a small nail 7-8 cm long." },
  { tr: "Uyurken boynunuzu desteklemek için yastığınız omuz yüksekliğinize uygun olmalıdır.", en: "To support your neck while sleeping, your pillow should match your shoulder height." },
  { tr: "Spor yaparken nefes tutmak, tansiyonun ani yükselmesine neden olacağı için tehlikelidir.", en: "Holding your breath while exercising is dangerous as it causes a sudden spike in blood pressure." },
  { tr: "Kalçadaki Gluteus Maximus kası, insan vücudundaki en büyük kastır ve yürüyüşümüzün temelidir.", en: "The Gluteus Maximus muscle in the hip is the largest muscle in the body and the core of our walk." },
  { tr: "Duruşunuzu düzelttiğiniz anda daha özgüvenli ve pozitif hissetmeye başlarsınız.", en: "The moment you fix your posture, you start to feel more confident and positive." },
  { tr: "Beynimiz ağrı hissetmez çünkü içinde ağrı reseptörleri yoktur; baş ağrısı kaslardan kaynaklanır.", en: "Our brain feels no pain because it has no pain receptors; headaches stem from muscles." },
  { tr: "Sabah aç karnına içilen bir bardak su, gece boyunca yavaşlayan metabolizmayı hızla uyandırır.", en: "A glass of water on an empty stomach in the morning quickly wakes up the metabolism slowed overnight." },
  { tr: "Ellerimizi hareket ettirmek, beyin korteksinde en çok alanı kaplayan fiziksel işlemdir.", en: "Moving our hands takes up the most space in the physical processing area of the brain cortex." },
  { tr: "Stres altındayken omuzlarınızı farkında olmadan kulaklarınıza doğru çekeriz, bu da ense ağrısı yapar.", en: "Under stress, we unconsciously pull our shoulders towards our ears, causing neck pain." },
  { tr: "Kalp kapakçıkları, kanın sadece tek yönde akmasını sağlayan mucizevi bir tasarıma sahiptir.", en: "Heart valves have a miraculous design that ensures blood flows in only one direction." },
  { tr: "Toprakta veya çimde çıplak ayakla yürümek (topraklanma), vücuttaki statik elektriği atar.", en: "Walking barefoot on soil or grass (grounding) discharges static electricity from the body." },
  { tr: "Pilates, sadece esnekliği değil aynı zamanda içsel dengeyi ve kas dayanıklılığını artırır.", en: "Pilates increases not only flexibility but also inner balance and muscle endurance." },
  { tr: "Cildimiz, vücudumuzun dış etkenlere karşı en büyük ve en güçlü savunma bariyeridir.", en: "Our skin is the body's largest and strongest defense barrier against external factors." },
  { tr: "Akıllı telefon kullanırken telefonu göz hizasında tutmak, 'mesaj boynu' hastalığını önler.", en: "Holding your smartphone at eye level prevents 'text neck' syndrome." },
  { tr: "Yüzme, eklemlere sıfır baskı uygulayarak tüm vücut kaslarını çalıştıran en güvenli spordur.", en: "Swimming is the safest sport that works all body muscles while putting zero pressure on joints." },
  { tr: "Ayak bileği burkulmaları, en sık karşılaşılan ve genellikle yanlış ayakkabıdan kaynaklanan sakatlıktır.", en: "Ankle sprains are the most common injury, often caused by incorrect footwear." },
  { tr: "Hafif bir müzik eşliğinde yapılan nefes egzersizleri, uykuya dalma süresini yarı yarıya kısaltır.", en: "Breathing exercises accompanied by soft music cut the time it takes to fall asleep in half." },
  { tr: "Bebekler doğduklarında 300 kemiğe sahiptir, büyüdükçe bu kemikler kaynayarak 206'ya düşer.", en: "Babies are born with 300 bones; as they grow, these fuse together down to 206." },
  { tr: "Göz bebeklerimiz yoğun bir duygu hissettiğimizde (örneğin sevgi) normalin 4 katına kadar büyüyebilir.", en: "Our pupils can expand up to 4 times their normal size when we feel intense emotion." },
  { tr: "Saçlarımız, kemik iliğimizden sonra vücudumuzda en hızlı büyüyen ikinci dokudur.", en: "Our hair is the second fastest-growing tissue in our body after bone marrow." },
  { tr: "Mide asidimiz o kadar güçlüdür ki, yanlışlıkla temas etse cildimizi bile tahriş edebilir.", en: "Our stomach acid is so strong that it could irritate our skin upon accidental contact." },
  { tr: "Uyku sırasında beynimiz anıları ayıklar, düzenler ve uzun süreli hafızaya kaydeder.", en: "During sleep, our brain sorts, organizes, and saves memories into long-term storage." },
  { tr: "Bel ağrılarının %80'i kemik veya fıtık değil, zayıf kaslar ve yanlış duruş kaynaklıdır.", en: "80% of lower back pains are caused not by bones or hernias, but by weak muscles and bad posture." },
  { tr: "Kas hafızası gerçektir; daha önce yaptığınız bir spora ara verseniz bile, kaslar o hareketi unutmaz.", en: "Muscle memory is real; even if you take a break from a sport, muscles don't forget the movement." },
  { tr: "Parmak eklemlerini çıtlatmak zararlı değildir; çıkan ses kemiklerden değil, patlayan hava kabarcıklarından gelir.", en: "Cracking your knuckles isn't harmful; the sound comes from popping air bubbles, not bones." },
  { tr: "Bademcikler, boğazdan giren bakteri ve virüsleri yakalayan bağışıklık sisteminin ilk askerleridir.", en: "Tonsils are the immune system's first soldiers, catching bacteria and viruses entering the throat." },
  { tr: "Sağ elimizi kullananların sağ tarafındaki tırnaklar, solakların ise sol tarafındaki tırnaklar daha hızlı uzar.", en: "Right-handed people's right nails grow faster, and left-handed people's left nails grow faster." },
  { tr: "Dil, insan vücudunda sadece tek bir ucundan tutunan (bağlı olan) tek kastır.", en: "The tongue is the only muscle in the human body that is attached at only one end." },
  { tr: "Düzenli esneme, kaslardaki laktik asidi dağıtarak kronik yorgunluk sendromunu hafifletir.", en: "Regular stretching relieves chronic fatigue syndrome by dispersing lactic acid in the muscles." },
  { tr: "Gülmek, yüzdeki kan akışını hızlandırdığı için cildin daha parlak ve genç görünmesini sağlar.", en: "Laughing makes the skin look brighter and younger because it increases blood flow to the face." },
  { tr: "Kalp atış hızımız, dinlediğimiz müziğin ritmine (bpm) göre senkronize olup hızlanabilir veya yavaşlayabilir.", en: "Our heart rate can sync, speed up, or slow down according to the rhythm of the music we listen to." },
  { tr: "Günde sadece 20 dakika açık havada bulunmak, D vitamini sentezini başlatarak kemikleri güçlendirir.", en: "Spending just 20 minutes outdoors a day starts Vitamin D synthesis, strengthening bones." },
  { tr: "Kanımızdaki beyaz kan hücreleri (alyuvarlar), vücuda giren enfeksiyonlara karşı adeta bir ordu gibi savaşır.", en: "White blood cells in our blood fight like an army against infections entering the body." },
  { tr: "Bacak bacak üstüne atarak oturmak, bacaklardaki kan damarlarına baskı yaparak varis oluşumunu tetikleyebilir.", en: "Sitting with crossed legs can trigger varicose veins by putting pressure on blood vessels." },
  { tr: "Vücudumuzdaki yağ hücreleri asla yok olmazlar, kilo verdiğimizde sadece boyut olarak küçülürler.", en: "Fat cells in our body never disappear; they only shrink in size when we lose weight." },
  { tr: "Yeni bir alışkanlık kazanmak veya eski bir alışkanlığı bırakmak ortalama 21 ila 66 gün sürer.", en: "Forming a new habit or breaking an old one takes an average of 21 to 66 days." },
  { tr: "Karaciğerimiz, kendini yenileyebilme özelliğine sahip tek iç organımızdır; bir kısmı kesilse bile yeniden büyüyebilir.", en: "Our liver is the only internal organ capable of regenerating; it can grow back even if a part is cut." },
  { tr: "Terin aslında hiçbir kokusu yoktur; kötü kokuyu oluşturan şey terin ciltteki bakterilerle birleşmesidir.", en: "Sweat actually has no odor; the bad smell is created when sweat combines with skin bacteria." },
  { tr: "Sabahları esnemek (gerinmek), uykuda biriken sıvıyı eklemlerden uzaklaştırarak bedeni hareket etmeye hazırlar.", en: "Stretching in the morning prepares the body for movement by pushing accumulated fluid away from joints." },
  { tr: "Gözyaşlarımız soğan doğradığımızda, güldüğümüzde ve ağladığımızda mikroskobik olarak farklı şekiller alır.", en: "Our tears take on microscopically different shapes when we chop onions, laugh, or cry." },
  { tr: "Uzun süre bilgisayar ekranına bakmak göz kırpma sayımızı yarı yarıya düşürür, bu da göz kuruluğuna yol açar.", en: "Staring at a computer screen halves our blink rate, leading to dry eyes." },
  { tr: "İnsan burnu 1 trilyondan fazla farklı kokuyu ayırt edebilir, bu beynin hafıza kısmıyla doğrudan bağlantılıdır.", en: "The human nose can distinguish over 1 trillion scents, which is directly linked to memory." },
  { tr: "Kulaklarımız ve burnumuz, yerçekiminin kıkırdaklara uyguladığı baskı nedeniyle ömrümüz boyunca büyümeye devam eder.", en: "Our ears and nose keep growing our whole lives due to gravity's pull on cartilage." },
  { tr: "Hapşırmak, bedenin solunum yollarındaki yabancı maddeleri saatte 160 km hızla dışarı fırlatma yöntemidir.", en: "Sneezing is the body's way of expelling foreign particles at a speed of 160 km/h." },
  { tr: "İnsan DNA'sı ile bir muzun DNA'sı yaklaşık %50 oranında birbirine benzerlik gösterir.", en: "Human DNA and a banana's DNA share about a 50% similarity." },
  { tr: "Sıcak bir banyo yapmak, uyku öncesi vücut ısısını düşürerek beyni derin uykuya geçişe hazırlar.", en: "Taking a hot bath drops body temperature before bed, preparing the brain for deep sleep." },
  { tr: "Omuz eklemi, vücudumuzdaki en geniş hareket açıklığına sahip, ancak çıkmaya en müsait eklemdir.", en: "The shoulder joint has the widest range of motion in our body but is the most prone to dislocation." },
  { tr: "Yeterince su içmemek, beyin dokusunun geçici olarak küçülmesine ve baş ağrılarına sebep olabilir.", en: "Not drinking enough water can temporarily shrink brain tissue and cause headaches." },
  { tr: "Kas kramplarının en yaygın sebebi kasların susuz veya magnezyum/potasyum gibi minerallerden yoksun kalmasıdır.", en: "The most common cause of muscle cramps is dehydration or a lack of minerals like magnesium." },
  { tr: "Sabahları zinde uyanmanın sırrı, alarmı ertelemeden (snooze yapmadan) ilk çalışta yataktan kalkmaktır.", en: "The secret to waking up fresh is getting out of bed on the first alarm without hitting snooze." },
  { tr: "Sağlıklı bir kalbin kasılma gücü, kanı yaklaşık 9 metre uzağa fırlatabilecek kadar kuvvetlidir.", en: "A healthy heart's contraction is powerful enough to squirt blood about 9 meters away." },
  { tr: "Omurga sağlığını korumak için ağır bir cisim kaldırırken belden değil, dizleri bükerek bacaklardan güç alınmalıdır.", en: "To protect the spine, lift heavy objects by bending the knees and using legs, not the back." },
  { tr: "Düzenli meditasyon yapmak, beynin strese yanıt veren amigdala bölgesinin küçülmesini sağlar.", en: "Regular meditation shrinks the amygdala, the brain's stress-responding region." },
  { tr: "Çocuklar bahar aylarında, kış aylarına oranla daha hızlı büyürler.", en: "Children grow faster in the spring months compared to the winter months." },
  { tr: "İnsan vücudu gece 02:00 ile 04:00 saatleri arasında biyolojik olarak en düşük vücut ısısına ulaşır.", en: "The human body reaches its lowest biological temperature between 02:00 and 04:00 at night." },
  { tr: "Kas dokusu, yağ dokusundan yaklaşık %15 daha yoğundur; bu yüzden aynı kiloda olsanız da daha ince görünebilirsiniz.", en: "Muscle is about 15% denser than fat; so you can look slimmer even at the same weight." },
  { tr: "Bir saat kitap okumak, zihni dinlendirerek kalp atış hızını sakinleştiren en etkili rahatlama yöntemlerinden biridir.", en: "Reading for an hour is one of the most effective ways to rest the mind and calm the heart rate." },
  { tr: "Diş minesi, insan vücudunda bulunan en sert maddedir; hatta kemiklerden bile daha serttir.", en: "Tooth enamel is the hardest substance in the human body; it is even harder than bones." },
  { tr: "Soğuk havalarda kaslarımız ısı üretmek için titrer, bu da egzersiz yapıyormuş gibi kalori yaktırır.", en: "In cold weather, our muscles shiver to produce heat, burning calories as if exercising." },
  { tr: "Beynimiz, geceleri uyurken gündüz olduğundan çok daha fazla aktiftir ve nöronal bağlar kurar.", en: "Our brain is much more active at night while sleeping, forming neuronal connections." },
  { tr: "Sol akciğerimiz, kalbe yer açmak için sağ akciğerimizden yaklaşık %10 daha küçüktür.", en: "Our left lung is about 10% smaller than our right lung to make room for the heart." },
  { tr: "İnsan bedeni her 3 ila 4 günde bir midesinin iç zarını tamamen yeniler, aksi takdirde asit mideyi delerdi.", en: "The human body renews its stomach lining every 3 to 4 days; otherwise, the acid would digest it." },
  { tr: "Sürekli sakız çiğnemek çene kaslarını aşırı yorarak şakaklarda gerilim tipi baş ağrısına yol açabilir.", en: "Constantly chewing gum overworks jaw muscles, leading to tension headaches in the temples." },
  { tr: "Egzersiz sonrası esneme (soğuma) hareketleri, kaslardaki gerginliği alarak bir sonraki antrenman için performans artırır.", en: "Post-workout stretching (cooling down) removes tension in muscles, increasing performance for the next session." }
];

export default function App() {
  const [lang, setLang] = useState('tr');
  const [userAuth, setUserAuth] = useState(null);
  const [step, setStep] = useState('welcome'); 
  const [loading, setLoading] = useState(false);

  const [durakId, setDurakId] = useState(null);

  const [emailInput, setEmailInput] = useState('');
  const [emailError, setEmailError] = useState('');
  const [checkingUser, setCheckingUser] = useState(false);

  const [sessionData, setSessionData] = useState({
    userDocId: '', email: '', alias: '', age: '', gender: '', selectedArea: '', completedExerciseId: '', completedExerciseTitle: '',
    totalPoints: 0, currentStreak: 0, lastExerciseDate: null, exercisesToday: 0, earnedBadges: [], breathingDays: []
  });
  
  const [aiAnswers, setAiAnswers] = useState({ time: '', weather: '', constraint: '', area: '' });
  const [isAiMode, setIsAiMode] = useState(false);
  const [filteredAIVideos, setFilteredAIVideos] = useState([]);
  
  const [autoData, setAutoData] = useState(null);
  const [isLocating, setIsLocating] = useState(false);
  
  const [aiMessage, setAiMessage] = useState({tr: '', en: ''});

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [sessionResult, setSessionResult] = useState({ pointsEarned: 0, newBadges: [] }); 
  const [showProfileModal, setShowProfileModal] = useState(false);
  
  const [showLeaderboardModal, setShowLeaderboardModal] = useState(false);
  const [leaderboardUsers, setLeaderboardUsers] = useState([]);
  const [leaderboardLoading, setLeaderboardLoading] = useState(false);

  const [timeLeft, setTimeLeft] = useState(0);
  const [isVideoFinished, setIsVideoFinished] = useState(false);
  const [currentFactIndex, setCurrentFactIndex] = useState(0);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [adminPasswordInput, setAdminPasswordInput] = useState('');
  const [loginError, setLoginError] = useState('');
  const [adminUsers, setAdminUsers] = useState([]);
  const [adminSessions, setAdminSessions] = useState([]); 
  const [selectedAdminUser, setSelectedAdminUser] = useState(null);
  const [adminTab, setAdminTab] = useState('list'); 
  const [selectedStationId, setSelectedStationId] = useState(null); 
  
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const [isClearing, setIsClearing] = useState(false);

  const [adminAiInsight, setAdminAiInsight] = useState('');
  const [isGeneratingInsight, setIsGeneratingInsight] = useState(false);

  const generateAdminInsight = async () => {
    setIsGeneratingInsight(true);
    try {
        const dataToAnalyze = {
            totalSessions: adminSessions.length,
            stations: {
                sihhiye: adminSessions.filter(s => ['30010', '30011', '30012', '30013', '30014', 'sihhiye_metro'].includes(s.locationId)).length,
                hacettepe: adminSessions.filter(s => ['30056', '30020', '30016', 'hacettepe_hastane'].includes(s.locationId)).length,
            },
            topPainArea: getMostFrequent(adminSessions.map(s => s.selectedArea).filter(Boolean)),
            topExercise: getMostFrequent(adminSessions.map(s => s.completedExerciseTitle).filter(Boolean)),
        };

        const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
        const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=$](https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=$){apiKey}`;
        const prompt = `As a Public Health and Urban Planning AI Consultant, analyze this bus stop physical therapy interaction data: ${JSON.stringify(dataToAnalyze)}. Provide a concise, 2-paragraph strategic insight report focusing on user behavior and infrastructural recommendations (like bench ergonomics or digital signage). Write the report in ${lang === 'tr' ? 'Turkish' : 'English'}.`;

        const payload = { contents: [{ parts: [{ text: prompt }] }] };
        const response = await fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        if (!response.ok) throw new Error("API responded with an error");
        const result = await response.json();
        const text = result.candidates?.[0]?.content?.parts?.[0]?.text;
        setAdminAiInsight(text || (lang === 'tr' ? 'Analiz üretilemedi.' : 'Could not generate analysis.'));
    } catch(e) {
        console.error("Gemini Admin Insight Error:", e);
        setAdminAiInsight(lang === 'tr' ? 'Yapay zeka analizi sırasında bir hata oluştu. Lütfen bağlantınızı kontrol edip tekrar deneyin.' : 'An error occurred during AI analysis.');
    }
    setIsGeneratingInsight(false);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const durakParam = params.get('durak');
    if (durakParam) setDurakId(durakParam);

    if (!auth) return;
    const initAuth = async () => {
      try {
        if (typeof __initial_auth_token !== 'undefined' && __initial_auth_token) await signInWithCustomToken(auth, __initial_auth_token);
        else await signInAnonymously(auth);
      } catch (error) { console.error("Auth error:", error); }
    };
    initAuth();
    const unsubscribe = onAuthStateChanged(auth, setUserAuth);
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    let timer; let factTimer;
    if (step === 'player' && !isVideoFinished) {
      timer = setInterval(() => {
        if (document.visibilityState === 'visible') {
          setTimeLeft((prev) => {
            if (prev <= 1) { setIsVideoFinished(true); clearInterval(timer); return 0; }
            return prev - 1;
          });
        }
      }, 1000);
      setCurrentFactIndex(Math.floor(Math.random() * healthFacts.length));
      factTimer = setInterval(() => setCurrentFactIndex(Math.floor(Math.random() * healthFacts.length)), 12000);
    }
    return () => { clearInterval(timer); clearInterval(factTimer); };
  }, [step, isVideoFinished]);

  useEffect(() => {
    if (step === 'ai-questions' && !autoData && !isLocating) {
      const fetchLocationAndWeather = async () => {
        setIsLocating(true);
        try {
          if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(async (pos) => {
              const { latitude, longitude } = pos.coords;
              
              let city = lang === 'tr' ? "Bulunduğunuz Konum" : "Current Location";
              try {
                const geoRes = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
                const geoData = await geoRes.json();
                city = geoData.address.city || geoData.address.town || geoData.address.suburb || geoData.address.county || city;
              } catch (e) { console.error("Geocoding error"); }

              let weatherType = 'normal';
              let weatherDesc = { tr: 'Bilinmiyor', en: 'Unknown' };
              let tempStr = '--';
              
              try {
                const weatherRes = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`);
                const weatherData = await weatherRes.json();
                const temp = weatherData.current_weather.temperature;
                const code = weatherData.current_weather.weathercode;
                tempStr = temp;

                if (code >= 50) {
                   weatherType = 'rain';
                   weatherDesc = {tr: `${temp}°C Yağmurlu`, en: `${temp}°C Rainy`};
                } else if (temp < 15) {
                   weatherType = 'cold';
                   weatherDesc = {tr: `${temp}°C Soğuk/Rüzgarlı`, en: `${temp}°C Cold/Windy`};
                } else {
                   weatherType = 'normal';
                   weatherDesc = {tr: `${temp}°C İdeal`, en: `${temp}°C Ideal`};
                }
              } catch (e) { console.error("Weather error"); }

              const hour = new Date().getHours();
              const mins = new Date().getMinutes();
              const timeStr = `${hour.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;

              setAutoData({ city, temp: tempStr, weatherDesc, timeStr });
              setAiAnswers(prev => ({...prev, weather: weatherType}));
              setIsLocating(false);

            }, (err) => {
              console.warn("Location denied or error");
              const hour = new Date().getHours();
              const timeStr = `${hour.toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`;
              setAutoData({ city: lang === 'tr' ? 'Konum İzni Yok' : 'Location Denied', temp: '--', weatherDesc: {tr: 'Varsayılan', en: 'Default'}, timeStr });
              setAiAnswers(prev => ({...prev, weather: 'normal'}));
              setIsLocating(false);
            });
          } else {
            setIsLocating(false);
          }
        } catch(e) {
          setIsLocating(false);
        }
      };
      fetchLocationAndWeather();
    }
  }, [step, autoData, isLocating, lang]);

  const handleGoHome = () => {
    setEmailInput('');
    setSessionData({ userDocId: '', email: '', alias: '', age: '', gender: '', selectedArea: '', completedExerciseId: '', completedExerciseTitle: '', totalPoints: 0, currentStreak: 0, lastExerciseDate: null, exercisesToday: 0, earnedBadges: [], breathingDays: [] });
    setIsAiMode(false); setAiAnswers({ time: '', weather: '', constraint: '', area: '' });
    setAutoData(null);
    setStep('welcome');
  };

  const handleEmailSubmit = async () => {
    if (!emailInput.includes('@') || !emailInput.includes('.')) { setEmailError(t[lang].invalidEmail); return; }
    setEmailError(''); setCheckingUser(true);
    if (db && userAuth) {
      try {
        const usersRef = collection(db, 'artifacts', appId, 'public', 'data', 'users');
        const usersSnap = await getDocs(usersRef);
        const existingDoc = usersSnap.docs.find(d => d.data().email === emailInput.trim().toLowerCase());
        if (existingDoc) {
          const userData = existingDoc.data();
          setSessionData(prev => ({ ...prev, userDocId: existingDoc.id, email: userData.email, alias: userData.alias, age: userData.age, gender: userData.gender, totalPoints: userData.totalPoints || 0, currentStreak: userData.currentStreak || 0, lastExerciseDate: userData.lastExerciseDate || null, exercisesToday: userData.exercisesToday || 0, earnedBadges: userData.earnedBadges || [], breathingDays: userData.breathingDays || [] }));
          setStep('mode-selection');
        } else {
          setSessionData(prev => ({ ...prev, email: emailInput.trim().toLowerCase(), alias: `Danışan ${usersSnap.docs.length + 1}` }));
          setStep('demographics');
        }
      } catch (error) { console.error(error); setStep('demographics'); }
    } else setStep('demographics');
    setCheckingUser(false);
  };

  const handleDemographicsSubmit = async () => {
    setLoading(true);
    if (db && userAuth) {
      try {
        const docRef = await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'users'), {
          email: sessionData.email, alias: sessionData.alias, age: sessionData.age, gender: sessionData.gender,
          totalPoints: 0, currentStreak: 0, lastExerciseDate: null, exercisesToday: 0, earnedBadges: [], breathingDays: [], createdAt: serverTimestamp()
        });
        setSessionData(prev => ({...prev, userDocId: docRef.id}));
      } catch (error) { console.error(error); }
    }
    setLoading(false);
    setStep('mode-selection');
  };

  const handleAIFilterSubmit = async () => {
    setStep('ai-loading');
    
    const areaKey = aiAnswers.area;
    const allVideosInArea = exerciseLibrary[areaKey] || [];
    
    let results = allVideosInArea.filter(ex => {
      let isMatch = true;
      if (aiAnswers.time === 'short' && !ex.tags.includes('short')) isMatch = false;
      if (aiAnswers.time === 'long' && !ex.tags.includes('long') && !ex.tags.includes('short')) isMatch = false;
      if (aiAnswers.weather === 'cold' && !ex.tags.includes('warmup')) isMatch = false;
      if (aiAnswers.weather === 'rain' && !ex.tags.includes('compact')) isMatch = false;
      if (aiAnswers.constraint === 'bag' && !ex.tags.includes('one-hand')) isMatch = false;
      if (aiAnswers.constraint === 'clothes' && !ex.tags.includes('no-bend')) isMatch = false;
      return isMatch;
    });

    if (results.length === 0) {
      results = allVideosInArea.filter(ex => ex.tags.includes('short') && ex.tags.includes('compact')).slice(0, 2);
    }
    
    let finalResults = results.slice(0, 3);
    if (!finalResults.some(ex => ex.title.toLowerCase().includes('solunum'))) {
      const breathingEx = allVideosInArea.find(ex => ex.title.toLowerCase().includes('solunum'));
      if(breathingEx) finalResults.push(breathingEx);
    }

    setFilteredAIVideos(finalResults);
    setSessionData(prev => ({...prev, selectedArea: areaKey}));

    const bestMatch = finalResults[0] || allVideosInArea[0];
    const hour = new Date().getHours();
    
    let timeStr = { tr: "günün bu saatinde", en: "at this time of day" };
    let timeTone = { tr: "Vaktini iyi değerlendirelim.", en: "Let's make good use of your time." };
    if (hour >= 6 && hour < 12) { timeStr = {tr: "sabahın bu saatinde", en: "this morning"}; timeTone = {tr: "Güne zinde başlamak için ideal bir an.", en: "An ideal moment to start the day fresh."}; }
    else if (hour >= 12 && hour < 18) { timeStr = {tr: "öğle saatlerinde", en: "this afternoon"}; timeTone = {tr: "Gün ortasında enerjini tazeleyelim.", en: "Let's refresh your energy mid-day."}; }
    else if (hour >= 18 && hour < 22) { timeStr = {tr: "akşam serinliğinde", en: "this evening"}; timeTone = {tr: "Günün yorgunluğunu atmak için harika bir fırsat.", en: "A great opportunity to relieve the day's fatigue."}; }
    else { timeStr = {tr: "gece saatlerinde", en: "tonight"}; timeTone = {tr: "Uyumadan önce vücudunu rahatlatalım.", en: "Let's relax your body before sleep."}; }

    let weatherTone = { tr: "", en: "" };
    if (aiAnswers.weather === 'cold') weatherTone = { tr: "Hava soğuk, kaslarını usulca ısıtacak bir başlangıç yapalım.", en: "It's cold, let's start with something to gently warm your muscles." };
    else if (aiAnswers.weather === 'normal') weatherTone = { tr: "Seni çok yormayacak hafif bir rutin seçtim.", en: "I chose a light routine that won't tire you out." };
    else weatherTone = { tr: "Yağmurlu havada, dar alanda bile rahatça yapabileceğin bir egzersiz buldum.", en: "I found an exercise you can easily do even in a tight space on a rainy day." };

    const sihhiyeCodes = ['30010', '30011', '30012', '30013', '30014', 'sihhiye_metro'];
    const hacettepeCodes = ['30056', '30020', '30016', 'hacettepe_hastane'];
    let stationName = { tr: "bulunduğun durakta", en: "at your current station" };
    let stationTone = { tr: "", en: "" };
    if (sihhiyeCodes.includes(durakId)) {
        stationName = { tr: "Sıhhiye Metro durağında", en: "at the Sıhhiye Metro station" };
        stationTone = { tr: "Metro trafiğinde enerjini yüksek tutman için daha dinamik hareketler seçtim.", en: "I selected dynamic movements to keep your energy high in metro traffic." };
    } else if (hacettepeCodes.includes(durakId)) {
        stationName = { tr: "Hacettepe Hastane durağında", en: "at the Hacettepe Hospital station" };
        stationTone = { tr: "Hastanede bekleme sürecini iyileştirici ve rahatlatıcı medikal hareketlerle destekleyelim.", en: "Let's support your hospital wait with soothing, medical movements." };
    }

    const age = sessionData.age || '25';
    const genderTr = sessionData.gender === 'Kadın' ? 'kadınsın' : sessionData.gender === 'Erkek' ? 'erkeksin' : 'bireysin';
    const genderEn = sessionData.gender === 'Kadın' ? 'woman' : sessionData.gender === 'Erkek' ? 'man' : 'person';
    const areaTr = areaTranslations[aiAnswers.area].tr.toLowerCase();
    const areaEn = areaTranslations[aiAnswers.area].en.toLowerCase();

    const fallbackMsgTr = `Hmm... ${age} yaşında bir ${genderTr} ve şu an ${stationName.tr} ${timeStr.tr} bekliyorsun. ${timeTone.tr} ${stationTone.tr} ${weatherTone.tr} Tüm bu şartlarını hesaplayarak; ${areaTr} bölgende hissettiğin gerginliği hafifletmek için, sadece ${bestMatch.duration} sürecek olan '${bestMatch.title}' videomu senin için özel olarak hazırladım. Sizin için en verimli seçim budur. Başlayalım mı?`;
    const fallbackMsgEn = `Hmm... you are a ${age}-year-old ${genderEn} waiting ${stationName.en} ${timeStr.en}. ${timeTone.en} ${stationTone.en} ${weatherTone.en} Considering all your conditions; to relieve the tension in your ${areaEn}, I have specially prepared the '${bestMatch.titleEn}' video which takes only ${bestMatch.durationEn}. This is the most efficient choice for you. Shall we begin?`;
    
    try {
        const apiKey = ""; 
        const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-3-flash-preview:generateContent?key=${apiKey}`;
        const prompt = `Context: ${age}-year-old ${genderEn} at ${stationName.en} (${timeStr.en}). Wait time: ${aiAnswers.time}. Weather: ${aiAnswers.weather}. Constraint: ${aiAnswers.constraint}. Pain: ${areaEn}. Recommended exercise: "${bestMatch.titleEn}" (${bestMatch.durationEn}).
Write a highly personalized, empathetic, 2-sentence intro message from the AI assistant "Fizyo-Zeka" to the user, explaining why this specific exercise is perfect for their current situation. Make it sound very natural and motivational. Do NOT use emojis.
Respond with a valid JSON object containing exactly two keys: 'tr' (Turkish translation) and 'en' (English translation).`;

        const payload = {
            contents: [{ parts: [{ text: prompt }] }],
            generationConfig: { responseMimeType: "application/json" }
        };

        const response = await fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        if (!response.ok) throw new Error("API error");
        const result = await response.json();
        const jsonText = result.candidates[0].content.parts[0].text;
        const generatedMsgs = JSON.parse(jsonText);

        setAiMessage({ tr: generatedMsgs.tr || fallbackMsgTr, en: generatedMsgs.en || fallbackMsgEn });
    } catch(e) {
        console.error("Gemini AI Integration Error:", e);
        setAiMessage({ tr: fallbackMsgTr, en: fallbackMsgEn }); 
    }

    setStep('ai-results');
  };

  const handleCompleteExercise = async () => {
    setLoading(true);
    let { totalPoints, currentStreak, lastExerciseDate, exercisesToday, earnedBadges, breathingDays, userDocId } = sessionData;
    let pointsEarnedNow = 0; let newBadgesUnlocked = [];
    const todayStr = new Date().toDateString();
    const yesterday = new Date(); yesterday.setDate(yesterday.getDate() - 1);
    
    if (lastExerciseDate !== todayStr) {
      if (lastExerciseDate === yesterday.toDateString()) currentStreak += 1;
      else currentStreak = 1;
      exercisesToday = 1; 
    } else exercisesToday += 1;

    if (exercisesToday <= 2) {
      pointsEarnedNow += 10; 
      if (currentStreak >= 3 && currentStreak % 3 === 0 && exercisesToday === 1) pointsEarnedNow += 10; 
    }
    totalPoints += pointsEarnedNow;

    const checkAndAwardBadge = (badgeId, condition, bonusPts) => {
      if (!earnedBadges.includes(badgeId) && condition) {
        earnedBadges.push(badgeId); newBadgesUnlocked.push(badgeId);
        totalPoints += bonusPts; pointsEarnedNow += bonusPts;
      }
    };
    
    checkAndAwardBadge('ilk_adim', true, 10);
    checkAndAwardBadge('istikrarli', currentStreak >= 3, 50);
    if (selectedVideo && selectedVideo.title.toLowerCase().includes('solunum') && !breathingDays.includes(todayStr)) breathingDays.push(todayStr);
    checkAndAwardBadge('zen', breathingDays.length >= 10, 100);
    
    checkAndAwardBadge('bronz', totalPoints >= 150, 0); 
    checkAndAwardBadge('gumus', totalPoints >= 400, 0); 
    checkAndAwardBadge('altin', totalPoints >= 650, 0);

    setSessionData(prev => ({ ...prev, totalPoints, currentStreak, lastExerciseDate: todayStr, exercisesToday, earnedBadges, breathingDays }));
    setSessionResult({ pointsEarned: pointsEarnedNow, newBadges: newBadgesUnlocked });

    if (db && userAuth) {
      try {
        await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'sessions'), { 
          alias: sessionData.alias, 
          age: sessionData.age, 
          gender: sessionData.gender, 
          selectedArea: sessionData.selectedArea, 
          completedExerciseId: selectedVideo.id, 
          completedExerciseTitle: selectedVideo.title, 
          locationId: durakId || 'Bilinmeyen Durak',
          timestamp: new Date().toISOString(), 
          serverTime: serverTimestamp() 
        });
        if (userDocId) await updateDoc(doc(db, 'artifacts', appId, 'public', 'data', 'users', userDocId), { totalPoints, currentStreak, lastExerciseDate: todayStr, exercisesToday, earnedBadges, breathingDays });
      } catch (error) { console.error(error); }
    }
    setLoading(false); setStep('success');
  };

  const handleAdminLogin = () => {
    if (adminPasswordInput === 'FizyoAdmin2026') { 
      setShowLoginModal(false); 
      setAdminPasswordInput(''); 
      setLoginError(''); 
      setStep('admin'); 
      setSelectedAdminUser(null); 
      setSelectedStationId(null);
      fetchDetailedAnalytics(); 
    } else setLoginError(t[lang].wrongPass);
  };

  const getMostFrequent = (arr) => {
    if (!arr || arr.length === 0) return 'NO_DATA';
    const counts = arr.reduce((acc, val) => {
      acc[val] = (acc[val] || 0) + 1;
      return acc;
    }, {});
    return Object.keys(counts).reduce((a, b) => counts[a] > counts[b] ? a : b);
  };

  const fetchDetailedAnalytics = async () => {
    if (!db || !userAuth) return;
    setLoading(true);
    try {
      const usersSnap = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', 'users'));
      const sessionsSnap = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', 'sessions'));
      const sessionsList = sessionsSnap.docs.map(d => d.data());
      
      setAdminSessions(sessionsList);

      const detailedUsers = usersSnap.docs.map(d => d.data()).map(user => {
        const userSessions = sessionsList.filter(s => s.alias === user.alias);
        let lastLogin = t[lang].noExercise;
        if (userSessions.length > 0) {
          userSessions.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
          lastLogin = new Date(userSessions[0].timestamp).toLocaleDateString('tr-TR') + ' - ' + new Date(userSessions[0].timestamp).toLocaleTimeString('tr-TR', {hour: '2-digit', minute:'2-digit'});
        }
        const areas = userSessions.map(s => s.selectedArea).filter(Boolean);
        const exercises = userSessions.map(s => s.completedExerciseTitle).filter(Boolean);
        
        const topAreaKey = getMostFrequent(areas);
        const favAreaTranslated = topAreaKey !== 'NO_DATA' ? (areaTranslations[topAreaKey]?.[lang] || topAreaKey) : t[lang].noData;
        const favEx = getMostFrequent(exercises) === 'NO_DATA' ? t[lang].noData : getMostFrequent(exercises);

        return { 
          ...user, 
          totalSessions: userSessions.length, 
          lastLoginDate: lastLogin, 
          favoriteArea: favAreaTranslated, 
          favoriteExercise: favEx 
        };
      }).sort((a, b) => (a.alias || "").localeCompare(b.alias || ""));
      setAdminUsers(detailedUsers);
    } catch (error) { console.error(error); }
    setLoading(false);
  };

  const exportToCSV = () => {
    const headers = ['Danisan Profil', 'Yas', 'Cinsiyet', 'Toplam Puan', 'Mevcut Seri', 'Rozet Sayisi', 'Toplam Egzersiz (Kez)', 'Son Giris Tarihi', 'En Cok Secilen Bolge', 'En Cok Yapilan Egzersiz'];
    const csvRows = [];
    csvRows.push(headers.join(','));
    adminUsers.forEach(user => {
      const row = [
        `"${user.alias}"`, `"${user.age}"`, `"${user.gender}"`, `"${user.totalPoints || 0}"`,
        `"${user.currentStreak || 0}"`, `"${(user.earnedBadges || []).length}"`, `"${user.totalSessions}"`,
        `"${user.lastLoginDate}"`, `"${user.favoriteArea}"`, `"${user.favoriteExercise}"`
      ];
      csvRows.push(row.join(','));
    });
    const csvString = csvRows.join('\n');
    const blob = new Blob(["\uFEFF" + csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "FizyoDurak_Danisan_Verileri.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const clearAllFirebaseData = async () => {
    if (!db || !userAuth) return;
    setIsClearing(true);
    try {
      const usersSnap = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', 'users'));
      const userDeletions = usersSnap.docs.map(d => deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'users', d.id)));
      
      const sessionsSnap = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', 'sessions'));
      const sessionDeletions = sessionsSnap.docs.map(d => deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'sessions', d.id)));
      
      await Promise.all([...userDeletions, ...sessionDeletions]);
      
      setAdminUsers([]);
      setAdminSessions([]);
      setShowClearConfirm(false);
    } catch (error) {
      console.error("Veri silme hatası:", error);
    }
    setIsClearing(false);
  };

  const fetchUserLeaderboard = async () => {
    if (!db || !userAuth) return;
    setLeaderboardLoading(true);
    try {
      const usersSnap = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', 'users'));
      const usersList = usersSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      usersList.sort((a, b) => (b.totalPoints || 0) - (a.totalPoints || 0));
      setLeaderboardUsers(usersList.slice(0, 20));
    } catch (error) { 
      console.error(error); 
    }
    setLeaderboardLoading(false);
  };

  const handleOpenLeaderboard = () => {
    setShowLeaderboardModal(true);
    fetchUserLeaderboard();
  };

  const renderMedicalWarnings = () => (
    <div className="flex flex-col min-h-full bg-white p-6 sm:p-8 animate-fade-in">
      <button onClick={handleGoHome} className="shrink-0 text-slate-500 mb-8 flex items-center hover:text-teal-600 font-semibold transition-colors w-fit">
        <ArrowLeft size={20} className="mr-2"/> {t[lang].back}
      </button>

      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-2">{t[lang].medWarning}</h2>
      <p className="shrink-0 text-slate-400 font-medium mb-8">Medical Disclaimer</p>
      
      <div className="text-slate-600 text-sm sm:text-base leading-relaxed space-y-8 pb-6">
        <p className="bg-slate-50 p-4 rounded-2xl border border-slate-100">
          {lang === 'tr' ? 'FizyoDurak uygulamasında sunulan tüm testler, anketler ve değerlendirmeler sadece genel bilgilendirme ve eğitim amaçlıdır. Bu bilgiler, herhangi bir sağlık probleminin teşhis veya tedavisinde kullanılmamalıdır.' : 'All tests, surveys, and assessments provided in the FizyoDurak app are for general informational and educational purposes only. This information should not be used in the diagnosis or treatment of any health problem.'}
        </p>

        <div>
          <h3 className="text-xl font-bold text-teal-600 mb-3 flex items-center"><Info className="mr-2" size={20}/> {lang === 'tr' ? '1. Tıbbi Tavsiye Değildir' : '1. Not Medical Advice'}</h3>
          <p className="mb-3">{lang === 'tr' ? 'Bu uygulama:' : 'This application:'}</p>
          <ul className="list-none space-y-2">
            <li className="flex items-center"><Check size={16} className="text-teal-500 mr-2"/> {lang === 'tr' ? 'Hastalık teşhisi koymaz' : 'Does not diagnose diseases'}</li>
            <li className="flex items-center"><Check size={16} className="text-teal-500 mr-2"/> {lang === 'tr' ? 'Klinik karar desteği sağlamaz' : 'Does not provide clinical decision support'}</li>
            <li className="flex items-center"><Check size={16} className="text-teal-500 mr-2"/> {lang === 'tr' ? 'Uzman görüşü yerine geçmez' : 'Does not replace expert opinion'}</li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-bold text-teal-600 mb-3 flex items-center"><Info className="mr-2" size={20}/> {lang === 'tr' ? '2. Acil Durumlarda Kullanılamaz' : '2. Cannot be Used in Emergencies'}</h3>
          <ul className="list-none space-y-2">
            <li className="flex items-start"><Check size={16} className="text-teal-500 mr-2 mt-1"/> <span>{lang === 'tr' ? 'Acil tıbbi durumlarda uygulama kullanılmamalıdır.' : 'The application should not be used in medical emergencies.'}</span></li>
            <li className="flex items-start"><Check size={16} className="text-teal-500 mr-2 mt-1"/> <span>{lang === 'tr' ? 'Derhal profesyonel yardım alınmalıdır.' : 'Seek professional help immediately.'}</span></li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-bold text-teal-600 mb-3 flex items-center"><Shield className="mr-2" size={20}/> {lang === 'tr' ? '3. Sorumluluk Reddi' : '3. Disclaimer of Liability'}</h3>
          <ul className="list-none space-y-2">
            <li className="flex items-start"><Check size={16} className="text-teal-500 mr-2 mt-1"/> <span>{lang === 'tr' ? 'Uygulamanın kullanılması sonucunda oluşabilecek her türlü yanlış anlama, karar, uygulama veya zarar kullanıcı sorumluluğundadır.' : 'Any misunderstanding, decision, action, or damage resulting from the use of the application is the sole responsibility of the user.'}</span></li>
            <li className="flex items-start"><Check size={16} className="text-teal-500 mr-2 mt-1"/> <span>{lang === 'tr' ? 'FizyoDurak Ekibi hiçbir zarardan sorumlu tutulamaz.' : 'The FizyoDurak Team cannot be held responsible for any damages.'}</span></li>
          </ul>
        </div>

        <div className="bg-teal-50/50 p-5 rounded-2xl border border-teal-100">
          <h3 className="text-lg font-bold text-teal-700 mb-2">{lang === 'tr' ? '4. İletişim' : '4. Contact'}</h3>
          <p>{lang === 'tr' ? 'Tıbbi uyarı ile ilgili iletişim adresi:' : 'Contact address regarding medical warning:'} <br/><a href="mailto:fizyodurak@gmail.com" className="text-teal-600 font-semibold hover:underline mt-1 inline-block">fizyodurak@gmail.com</a></p>
        </div>
      </div>
    </div>
  );

  const renderTermsOfUse = () => (
    <div className="flex flex-col min-h-full bg-white p-6 sm:p-8 animate-fade-in">
      <button onClick={handleGoHome} className="shrink-0 text-slate-500 mb-8 flex items-center hover:text-teal-600 font-semibold transition-colors w-fit">
        <ArrowLeft size={20} className="mr-2"/> {t[lang].back}
      </button>
      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-6">{t[lang].terms}</h2>
      <div className="text-slate-600 text-sm sm:text-base leading-relaxed space-y-4 pb-6">
        <p className="font-medium text-slate-700">{lang === 'tr' ? 'FizyoDurak platformunu kullanarak aşağıdaki şartları kabul etmiş sayılırsınız:' : 'By using the FizyoDurak platform, you agree to the following terms:'}</p>
        <ul className="list-disc pl-5 space-y-3">
          <li>{lang === 'tr' ? 'Platformda yer alan içerikler, videolar ve yönlendirmeler profesyonel tıbbi tedavinin yerini almaz.' : 'Contents, videos, and directions on the platform do not replace professional medical treatment.'}</li>
          <li>{lang === 'tr' ? 'Kullanıcı, egzersizleri uygularken kendi fiziksel sınırlarını bilmeli ve ağrı hissettiğinde derhal bırakmalıdır.' : 'The user must know their physical limits while performing exercises and stop immediately if pain is felt.'}</li>
          <li>{lang === 'tr' ? 'Sistemde depolanan anonim veriler (yaş, cinsiyet, egzersiz tercihleri) proje geliştirme amaçlı kullanılabilir.' : 'Anonymous data stored in the system (age, gender, exercise preferences) can be used for project development purposes.'}</li>
          <li>{lang === 'tr' ? 'Uygulamanın kesintisiz veya hatasız çalışacağı garanti edilmemektedir.' : 'There is no guarantee that the application will run uninterrupted or error-free.'}</li>
        </ul>
      </div>
    </div>
  );

  const renderPrivacyPolicy = () => (
    <div className="flex flex-col min-h-full bg-white p-6 sm:p-8 animate-fade-in">
      <button onClick={handleGoHome} className="shrink-0 text-slate-500 mb-8 flex items-center hover:text-teal-600 font-semibold transition-colors w-fit">
        <ArrowLeft size={20} className="mr-2"/> {t[lang].back}
      </button>
      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-6">{t[lang].privacy}</h2>
      <div className="text-slate-600 text-sm sm:text-base leading-relaxed space-y-6 pb-6">
        <p className="font-medium text-slate-700 bg-slate-50 p-4 rounded-2xl">{lang === 'tr' ? 'FizyoDurak olarak kullanıcı gizliliğine maksimum düzeyde saygı gösteriyoruz.' : 'As FizyoDurak, we respect user privacy to the maximum extent.'}</p>
        <ul className="space-y-4">
          <li className="flex items-start">
             <div className="bg-teal-100 p-2 rounded-lg mr-4 mt-1"><User size={16} className="text-teal-700"/></div>
             <div>
                <strong className="text-slate-800 block mb-1">{lang === 'tr' ? 'Veri Toplama:' : 'Data Collection:'}</strong> 
                {lang === 'tr' ? 'E-posta adresiniz sadece sizi tanımak ve bir sonraki girişinizde size kolaylık sağlamak için alınır. Üçüncü şahıslarla paylaşılmaz.' : 'Your e-mail address is only taken to recognize you and provide convenience for your next login. It is not shared with third parties.'}
             </div>
          </li>
          <li className="flex items-start">
             <div className="bg-emerald-100 p-2 rounded-lg mr-4 mt-1"><Activity size={16} className="text-emerald-700"/></div>
             <div>
                <strong className="text-slate-800 block mb-1">{lang === 'tr' ? 'Kullanım Verileri:' : 'Usage Data:'}</strong> 
                {lang === 'tr' ? 'Hangi egzersizleri seçtiğiniz, yaş ve cinsiyet gibi bilgiler tamamen anonimleştirilerek proje istatistiklerinde kullanılır.' : 'Information such as which exercises you choose, age, and gender are completely anonymized and used in project statistics.'}
             </div>
          </li>
          <li className="flex items-start">
             <div className="bg-blue-100 p-2 rounded-lg mr-4 mt-1"><Shield size={16} className="text-blue-700"/></div>
             <div>
                <strong className="text-slate-800 block mb-1">{lang === 'tr' ? 'Veri Güvenliği:' : 'Data Security:'}</strong> 
                {lang === 'tr' ? 'Tüm verileriniz güvenli bulut sunucularında (Google Firebase) şifrelenerek saklanmaktadır.' : 'All your data is securely stored encrypted on cloud servers (Google Firebase).'}
             </div>
          </li>
        </ul>
      </div>
    </div>
  );

  const renderWelcome = () => (
    <div className="flex flex-col min-h-full bg-white">
      <div className="flex-col items-center justify-center text-center p-6 sm:p-8 relative shrink-0">
        <button 
          onClick={() => setShowLoginModal(true)}
          className="absolute top-6 left-6 p-3 text-slate-300 hover:text-teal-600 transition-colors z-20 rounded-full hover:bg-slate-50"
        >
          <Lock size={20} />
        </button>

        <div className="w-32 h-32 mx-auto rounded-3xl flex items-center justify-center mb-6 shadow-[0_8px_30px_rgb(0,0,0,0.08)] overflow-hidden bg-white border border-slate-100 transform transition hover:scale-105 duration-300">
          <img 
            src="/logo.png" 
            alt="FizyoDurak Logo" 
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.onerror = null; 
              e.target.src = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24' fill='none' stroke='%230d9488' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z'/></svg>";
            }} 
          />
        </div>
        
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-700 to-emerald-500 mb-3">{t[lang].appTitle}</h1>
        <p className="text-slate-500 text-lg font-medium mb-8 px-4">{t[lang].welcomeSub}</p>

        <div className="w-full bg-white border border-slate-200/60 rounded-3xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] text-left mb-6">
          <label className="block text-sm font-bold text-slate-700 mb-3 ml-1">{t[lang].emailLabel}</label>
          <div className="relative group">
            <Mail className="absolute left-4 top-4 text-slate-400 group-focus-within:text-teal-500 transition-colors" size={22} />
            <input
              type="email"
              placeholder={t[lang].emailPlaceholder}
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleEmailSubmit()}
              className="w-full py-4 pl-12 pr-4 rounded-2xl bg-slate-50 border border-slate-200 focus:bg-white focus:border-teal-500 focus:ring-4 focus:ring-teal-500/10 outline-none transition-all text-slate-800 font-medium"
            />
          </div>
          {emailError && <p className="text-rose-500 text-sm mt-3 ml-1 flex items-center"><Info size={14} className="mr-1"/>{emailError}</p>}
        </div>

        <button 
          onClick={handleEmailSubmit}
          disabled={checkingUser}
          className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-bold py-4 rounded-2xl shadow-lg shadow-teal-500/30 hover:shadow-teal-500/50 hover:-translate-y-0.5 transition-all active:scale-95 text-lg"
        >
          {checkingUser ? t[lang].checking : t[lang].loginBtn}
        </button>
      </div>

      <div className="mt-auto shrink-0 bg-slate-50 p-6 sm:p-8 text-sm text-slate-600 border-t border-slate-200/60 rounded-b-[2.5rem]">
        <div className="flex items-center space-x-3 mb-5">
           <div className="w-10 h-10 rounded-xl overflow-hidden bg-white shadow-sm flex-shrink-0 border border-slate-100">
             <img src="/logo.png" alt="Logo" className="w-full h-full object-cover" />
           </div>
           <span className="font-extrabold text-xl text-slate-800 tracking-tight">{t[lang].appTitle}</span>
        </div>
        
        <p className="mb-8 text-slate-500 leading-relaxed font-medium">
          {t[lang].footerDesc}
        </p>

        <div className="grid grid-cols-2 gap-6 mb-8">
          <div>
            <h4 className="font-bold text-slate-800 mb-4 uppercase tracking-wider text-xs">{t[lang].contact}</h4>
            <div className="flex items-center space-x-2 text-teal-600 font-medium">
                <Mail size={16} className="flex-shrink-0" />
                <a href="mailto:fizyodurak@gmail.com" className="hover:text-teal-700 transition-colors break-all">fizyodurak@gmail.com</a>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold text-slate-800 mb-4 uppercase tracking-wider text-xs">{t[lang].legal}</h4>
            <ul className="space-y-3 text-slate-500 font-medium">
                <li><button onClick={() => setStep('terms-of-use')} className="hover:text-teal-600 transition-colors text-left flex items-center"><FileText size={14} className="mr-2"/>{t[lang].terms}</button></li>
                <li><button onClick={() => setStep('privacy-policy')} className="hover:text-teal-600 transition-colors text-left flex items-center"><Shield size={14} className="mr-2"/>{t[lang].privacy}</button></li>
                <li><button onClick={() => setStep('medical-warnings')} className="hover:text-teal-600 transition-colors text-left flex items-center"><Info size={14} className="mr-2"/>{t[lang].medWarning}</button></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200/80 pt-6 text-xs text-slate-400 text-center font-medium">
            {t[lang].rights}
        </div>
      </div>

      {showLoginModal && (
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm flex flex-col items-center justify-center p-6 z-50 animate-fade-in">
          <div className="bg-white w-full max-w-sm rounded-[2rem] shadow-2xl p-8 relative flex flex-col items-center">
            <button onClick={() => setShowLoginModal(false)} className="absolute top-5 right-5 text-slate-400 hover:text-slate-700 transition-colors bg-slate-50 p-2 rounded-full">
              <X size={20} />
            </button>
            <div className="w-16 h-16 bg-teal-50 rounded-2xl flex items-center justify-center mb-4 text-teal-600">
              <Lock size={28} />
            </div>
            <h3 className="text-2xl font-bold text-slate-800 mb-2 text-center">{t[lang].adminLogin}</h3>
            <p className="text-slate-500 text-sm mb-8 text-center font-medium">{t[lang].adminLoginSub}</p>
            
            <div className="w-full relative mb-2">
              <input 
                type="password" 
                placeholder={t[lang].password}
                value={adminPasswordInput}
                onChange={(e) => setAdminPasswordInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAdminLogin()}
                className="w-full py-3.5 px-5 rounded-2xl bg-slate-50 border border-slate-200 focus:bg-white focus:border-teal-500 focus:ring-4 focus:ring-teal-500/10 outline-none transition-all text-slate-800 font-medium"
              />
            </div>
            {loginError && <p className="text-rose-500 text-sm w-full text-left mb-6 font-medium flex items-center"><Info size={14} className="mr-1"/>{loginError}</p>}
            
            <button 
              onClick={handleAdminLogin}
              className="w-full bg-slate-800 text-white font-bold py-4 rounded-2xl hover:bg-slate-900 transition-all shadow-lg shadow-slate-800/20 active:scale-95 mt-4"
            >
              {t[lang].login}
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const renderDemographics = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-white">
      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-3">{t[lang].demoTitle}</h2>
      <p className="shrink-0 text-slate-500 font-medium text-lg mb-8">{t[lang].demoSub}</p>
      
      <div className="space-y-8 flex-grow pb-6">
        <div className="bg-white border border-slate-100 p-6 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] shrink-0">
          <label className="block text-sm font-bold text-slate-700 mb-3 ml-1">{t[lang].ageLabel}</label>
          <input
            type="number"
            placeholder={t[lang].agePlaceholder}
            value={sessionData.age}
            onChange={(e) => setSessionData(prev => ({...prev, age: e.target.value}))}
            className="w-full py-4 px-5 rounded-2xl bg-slate-50 border border-slate-200 focus:bg-white focus:border-teal-500 focus:ring-4 focus:ring-teal-500/10 outline-none transition-all text-slate-800 font-medium text-lg"
          />
        </div>
        
        <div className="bg-white border border-slate-100 p-6 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] shrink-0">
          <label className="block text-sm font-bold text-slate-700 mb-4 ml-1">{t[lang].genderLabel}</label>
          <div className="grid grid-cols-2 gap-3">
            {genderOptions.map(option => {
              const isSelected = sessionData.gender === option.id;
              return (
                <button
                  key={option.id}
                  onClick={() => setSessionData(prev => ({...prev, gender: option.id}))}
                  className={`py-4 px-2 rounded-2xl border-2 transition-all font-bold text-sm sm:text-base ${
                    isSelected 
                      ? 'border-teal-500 bg-teal-500 text-white shadow-md shadow-teal-500/20' 
                      : 'border-slate-100 bg-slate-50 text-slate-600 hover:bg-slate-100 hover:border-slate-200'
                  } ${option.id === 'Belirtmek İstemiyorum' ? 'col-span-2' : ''}`}
                >
                  {option[lang]} 
                </button>
              )
            })}
          </div>
        </div>
      </div>
      
      <button 
        disabled={!sessionData.age || !sessionData.gender || loading}
        onClick={handleDemographicsSubmit}
        className={`w-full font-bold py-4 rounded-2xl transition-all text-lg flex justify-center items-center shrink-0 mb-4 mt-2 ${
          (!sessionData.age || !sessionData.gender)
            ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
            : 'bg-slate-800 text-white hover:bg-slate-900 shadow-lg shadow-slate-800/20 active:scale-95'
        }`}
      >
        {loading ? t[lang].saving : <>{t[lang].next} <ArrowRight className="ml-2" size={20} /></>}
      </button>
    </div>
  );

  const renderModeSelection = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-slate-50/50">
      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-3">{t[lang].modeTitle}</h2>
      <p className="shrink-0 text-slate-500 font-medium text-lg mb-8">{t[lang].modeSub}</p>
      
      <div className="space-y-5 flex-grow pb-6">
        <button 
          onClick={() => { setIsAiMode(true); setStep('ai-questions'); }}
          className="shrink-0 w-full group bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 p-1 rounded-[2rem] shadow-[0_8px_30px_rgb(99,102,241,0.2)] hover:shadow-[0_8px_30px_rgb(99,102,241,0.4)] transition-all duration-300 hover:-translate-y-1 text-left"
        >
          <div className="bg-white/10 backdrop-blur-md rounded-[1.8rem] p-6 h-full w-full flex items-center">
             <div className="bg-white/20 p-4 rounded-2xl mr-5 group-hover:scale-110 transition-transform">
               <BrainCircuit size={32} className="text-white" />
             </div>
             <div>
                <h3 className="text-2xl font-extrabold text-white mb-1">{t[lang].modeAI}</h3>
                <p className="text-indigo-100 font-medium">{t[lang].modeAIAux}</p>
             </div>
          </div>
        </button>

        <button 
          onClick={() => { setIsAiMode(false); setStep('body-part'); }}
          className="shrink-0 w-full group bg-white border border-slate-200 p-6 rounded-[2rem] shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:border-teal-400 hover:shadow-[0_8px_30px_rgb(13,148,136,0.1)] transition-all duration-300 hover:-translate-y-1 text-left flex items-center"
        >
           <div className="bg-slate-100 p-4 rounded-2xl mr-5 group-hover:bg-teal-50 transition-colors group-hover:scale-110">
             <ListVideo size={32} className="text-slate-500 group-hover:text-teal-500 transition-colors" />
           </div>
           <div>
              <h3 className="text-2xl font-extrabold text-slate-800 mb-1">{t[lang].modeManual}</h3>
              <p className="text-slate-500 font-medium">{t[lang].modeManualAux}</p>
           </div>
        </button>
      </div>
    </div>
  );

  const renderAIQuestions = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-slate-50/50">
      <button onClick={() => setStep('mode-selection')} className="shrink-0 text-slate-500 mb-6 flex items-center hover:text-indigo-600 font-semibold w-fit bg-white px-4 py-2 rounded-xl shadow-sm border border-slate-200">
        <ArrowLeft size={18} className="mr-2"/> {t[lang].back}
      </button>
      
      <div className="shrink-0 flex items-center mb-6">
         <BrainCircuit className="text-indigo-500 mr-3" size={28}/>
         <h2 className="text-2xl font-extrabold text-slate-800">AI Analiz Formu</h2>
      </div>

      <div className="space-y-6 flex-grow pb-6">
        <div className="shrink-0 bg-white p-5 rounded-3xl border border-slate-100 shadow-sm">
          <p className="font-bold text-slate-700 mb-3 flex items-center"><Timer size={18} className="mr-2 text-slate-400"/> {t[lang].aiQ1}</p>
          <div className="grid grid-cols-2 gap-3">
            <button onClick={() => setAiAnswers(p=>({...p, time: 'short'}))} className={`py-3 rounded-2xl font-bold border-2 transition-all ${aiAnswers.time === 'short' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-slate-100 bg-slate-50 text-slate-600'}`}>{t[lang].aiTimeShort}</button>
            <button onClick={() => setAiAnswers(p=>({...p, time: 'long'}))} className={`py-3 rounded-2xl font-bold border-2 transition-all ${aiAnswers.time === 'long' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-slate-100 bg-slate-50 text-slate-600'}`}>{t[lang].aiTimeLong}</button>
          </div>
        </div>

        {isLocating || !autoData ? (
           <div className="shrink-0 animate-pulse bg-indigo-50/50 p-6 rounded-3xl border border-indigo-100 flex flex-col items-center justify-center space-y-3">
             <Activity className="animate-spin text-indigo-500" size={32}/>
             <span className="text-indigo-600 font-bold text-sm">{lang === 'tr' ? 'Fizyo-Zeka Çevresel Verileri Çekiyor...' : 'Fetching Environmental Data...'}</span>
           </div>
        ) : (
           <div className="shrink-0 bg-gradient-to-r from-indigo-500 to-purple-600 p-5 rounded-3xl text-white shadow-lg flex items-center justify-between relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl -mr-10 -mt-10"></div>
              <div className="flex flex-col relative z-10">
                 <span className="text-indigo-100 text-xs font-bold uppercase tracking-wider mb-1"><MapPin size={14} className="inline mr-1 mb-0.5"/> {autoData.city}</span>
                 <span className="text-3xl font-black tracking-tight">{autoData.timeStr}</span>
              </div>
              <div className="h-12 w-px bg-white/20 mx-4 relative z-10"></div>
              <div className="flex flex-col items-end relative z-10">
                 <span className="text-indigo-100 text-xs font-bold uppercase tracking-wider mb-1">{lang === 'tr' ? 'Durak Şartları' : 'Station Conditions'}</span>
                 <span className="text-lg font-bold flex items-center text-right">
                   {aiAnswers.weather === 'rain' ? <CloudRain size={20} className="mr-1.5 text-blue-200"/> : aiAnswers.weather === 'cold' ? <Wind size={20} className="mr-1.5 text-cyan-200"/> : <Sun size={20} className="mr-1.5 text-amber-200"/>}
                   {autoData.weatherDesc[lang]}
                 </span>
              </div>
           </div>
        )}

        <div className="shrink-0 bg-white p-5 rounded-3xl border border-slate-100 shadow-sm">
          <p className="font-bold text-slate-700 mb-3 flex items-center"><Accessibility size={18} className="mr-2 text-slate-400"/> {t[lang].aiQ3}</p>
          <div className="grid grid-cols-1 gap-2">
            <button onClick={() => setAiAnswers(p=>({...p, constraint: 'none'}))} className={`flex items-center p-3 rounded-2xl font-bold border-2 transition-all ${aiAnswers.constraint === 'none' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-slate-100 bg-slate-50 text-slate-600'}`}>{t[lang].aiConstNone}</button>
            <button onClick={() => setAiAnswers(p=>({...p, constraint: 'bag'}))} className={`flex items-center p-3 rounded-2xl font-bold border-2 transition-all ${aiAnswers.constraint === 'bag' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-slate-100 bg-slate-50 text-slate-600'}`}><Briefcase className="mr-3" size={20}/> {t[lang].aiConstBag}</button>
            <button onClick={() => setAiAnswers(p=>({...p, constraint: 'clothes'}))} className={`flex items-center p-3 rounded-2xl font-bold border-2 transition-all ${aiAnswers.constraint === 'clothes' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-slate-100 bg-slate-50 text-slate-600'}`}>{t[lang].aiConstClothes}</button>
          </div>
        </div>

        <div className="shrink-0 bg-white p-5 rounded-3xl border border-slate-100 shadow-sm">
          <p className="font-bold text-slate-700 mb-3 flex items-center"><Activity size={18} className="mr-2 text-slate-400"/> {t[lang].whereHurts}</p>
          <div className="grid grid-cols-2 gap-3">
            {Object.keys(exerciseLibrary).map(area => (
              <button key={area} onClick={() => setAiAnswers(p=>({...p, area: area}))} className={`py-3 rounded-2xl font-bold border-2 transition-all ${aiAnswers.area === area ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-slate-100 bg-slate-50 text-slate-600'}`}>{areaTranslations[area][lang]}</button>
            ))}
          </div>
        </div>
      </div>

      <button 
        disabled={!aiAnswers.time || !aiAnswers.weather || !aiAnswers.constraint || !aiAnswers.area || isLocating}
        onClick={handleAIFilterSubmit}
        className={`shrink-0 w-full font-bold py-4.5 rounded-2xl transition-all text-lg mt-4 mb-4 flex justify-center items-center shadow-lg ${
          (!aiAnswers.time || !aiAnswers.weather || !aiAnswers.constraint || !aiAnswers.area || isLocating)
            ? 'bg-slate-200 text-slate-400 shadow-none cursor-not-allowed'
            : 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-indigo-500/40 hover:-translate-y-1'
        }`}
        style={{ minHeight: '60px' }}
      >
        {t[lang].analyzeBtn} <BrainCircuit className="ml-2" size={20} />
      </button>
    </div>
  );

  const renderAILoading = () => (
    <div className="flex flex-col items-center justify-center min-h-full animate-fade-in p-6 bg-slate-900 text-white text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
      <div className="w-32 h-32 rounded-full border-4 border-indigo-500/30 flex items-center justify-center relative mb-8 shrink-0">
         <div className="absolute inset-0 rounded-full border-t-4 border-indigo-400 animate-spin"></div>
         <BrainCircuit size={48} className="text-indigo-400 animate-pulse" />
      </div>
      <h2 className="text-3xl font-extrabold mb-3 shrink-0">{t[lang].aiAnalyzing}</h2>
      <p className="text-indigo-200/70 font-medium px-4 shrink-0">{t[lang].aiAnalyzingSub}</p>
    </div>
  );

  const renderAIResults = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-indigo-50/50">
      <div className="flex items-center justify-between mb-6 shrink-0">
        <button onClick={() => setStep('ai-questions')} className="text-indigo-500 flex items-center hover:text-indigo-700 font-bold transition-colors bg-white px-4 py-2 rounded-xl shadow-sm border border-indigo-100 w-fit">
          <ArrowLeft size={18} className="mr-2"/> {t[lang].changeBtn}
        </button>
      </div>

      <div className="flex items-start space-x-3 mb-6 animate-fade-in shrink-0">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shrink-0 shadow-lg border-2 border-white">
              <BrainCircuit size={24} />
          </div>
          <div className="bg-white p-4 sm:p-5 rounded-2xl rounded-tl-none border border-indigo-100 shadow-[0_8px_30px_rgb(99,102,241,0.12)] relative">
              <div className="absolute top-[-6px] left-[-6px] w-4 h-4 bg-white border-t border-l border-indigo-100 transform -rotate-45"></div>
              <p className="text-slate-700 text-sm font-medium leading-relaxed">
                  {aiMessage[lang]}
              </p>
          </div>
      </div>
      
      <div className="shrink-0 bg-gradient-to-r from-indigo-600 to-purple-600 p-5 rounded-3xl text-white shadow-lg shadow-indigo-500/20 mb-6">
        <h2 className="text-xl font-extrabold mb-1 flex items-center"><CheckCircle className="mr-2" size={20}/> {t[lang].aiResultsTitle}</h2>
        <p className="text-indigo-100 text-xs font-medium">{t[lang].aiResultsSub}</p>
      </div>

      <div className="space-y-5 flex-grow pb-6">
        {filteredAIVideos.map((video, idx) => (
          <div 
            key={video.id} 
            className="shrink-0 group bg-white border border-indigo-100 rounded-3xl overflow-hidden shadow-sm hover:shadow-[0_8px_30px_rgb(99,102,241,0.15)] transition-all duration-300 hover:-translate-y-1 cursor-pointer flex flex-col relative"
            onClick={() => {
              const seconds = parseInt(video.duration) * 60 || 45; 
              setTimeLeft(seconds); setIsVideoFinished(false); setSelectedVideo(video); setStep('player');
            }}
          >
            {idx === 0 && <div className="absolute top-0 right-0 bg-amber-400 text-white text-[10px] font-black px-3 py-1 rounded-bl-xl z-30 uppercase tracking-widest">{t[lang].bestMatch}</div>}
            <div className="h-32 bg-indigo-900/5 relative flex items-center justify-center">
              {video.videoUrl ? (
                <div className="absolute inset-0 bg-indigo-900/10 flex items-center justify-center z-20 backdrop-blur-[1px] group-hover:backdrop-blur-none transition-all">
                  <PlayCircle size={48} className="text-white drop-shadow-md transform group-hover:scale-110 transition-transform duration-300" />
                </div>
              ) : (
                <PlayCircle size={48} className="text-indigo-300 transform group-hover:scale-110 group-hover:text-indigo-500 transition-all duration-300 z-20" />
              )}
              <div className="absolute bottom-3 right-3 bg-indigo-900/70 text-white text-xs font-bold px-3 py-1.5 rounded-lg z-20">
                {lang === 'tr' ? video.duration : video.durationEn}
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-extrabold text-slate-800 text-lg group-hover:text-indigo-600 transition-colors line-clamp-1">{lang === 'tr' ? video.title : video.titleEn}</h3>
              <p className="text-slate-500 text-sm mt-1.5 font-medium line-clamp-2 leading-relaxed">{lang === 'tr' ? video.description : video.descriptionEn}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderBodyPartSelection = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-slate-50/50">
      <button onClick={() => setStep('mode-selection')} className="shrink-0 text-slate-500 mb-6 flex items-center hover:text-teal-600 font-semibold w-fit bg-white px-4 py-2 rounded-xl shadow-sm border border-slate-200">
        <ArrowLeft size={18} className="mr-2"/> {t[lang].back}
      </button>
      <div className="shrink-0 bg-white border border-slate-200/60 text-slate-600 text-sm font-medium py-3 px-5 rounded-2xl mb-8 text-center shadow-sm flex items-center justify-center">
        <User size={16} className="mr-2 text-teal-500"/>
        {t[lang].regAs} <span className="font-bold text-slate-800 mx-1">{sessionData.alias}</span>{t[lang].regAs2}
      </div>
      
      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-3">{t[lang].whereHurts}</h2>
      <p className="shrink-0 text-slate-500 font-medium text-lg mb-8">{t[lang].selectArea}</p>
      
      <div className="grid grid-cols-1 gap-4 flex-grow pb-6">
        {Object.keys(exerciseLibrary).map((areaKey) => (
          <button
            key={areaKey}
            onClick={() => {
              setSessionData(prev => ({...prev, selectedArea: areaKey}));
              setStep('videos');
            }}
            className="shrink-0 group flex items-center justify-between p-5 bg-white border border-slate-200/60 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)] hover:shadow-[0_8px_30px_rgb(13,148,136,0.12)] hover:border-teal-300 transition-all duration-300 hover:-translate-y-1"
          >
            <div className="flex items-center space-x-5">
              <div className="bg-gradient-to-br from-teal-50 to-emerald-50 w-16 h-16 rounded-2xl flex items-center justify-center text-3xl shadow-sm border border-teal-100/50 group-hover:scale-110 transition-transform">
                {areaVisuals[areaKey]}
              </div>
              <span className="text-lg font-bold text-slate-700 group-hover:text-teal-700 transition-colors">{areaTranslations[areaKey][lang]}</span>
            </div>
            <div className="bg-slate-50 p-2 rounded-full group-hover:bg-teal-50 transition-colors">
               <ChevronRight className="text-slate-400 group-hover:text-teal-600 transition-colors" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );

  const renderVideos = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-slate-50/50">
      <button onClick={() => setStep('body-part')} className="shrink-0 text-slate-500 mb-6 flex items-center hover:text-teal-600 font-semibold transition-colors w-fit bg-white px-4 py-2 rounded-xl shadow-sm border border-slate-200/60">
        <ArrowLeft size={18} className="mr-2"/> {t[lang].back}
      </button>
      <h2 className="shrink-0 text-3xl font-extrabold text-slate-800 mb-3">{areaTranslations[sessionData.selectedArea][lang]}</h2>
      <p className="shrink-0 text-slate-500 font-medium text-lg mb-8">{t[lang].exercisesForYou}</p>
      
      <div className="space-y-5 flex-grow pb-6">
        {exerciseLibrary[sessionData.selectedArea].map((video) => (
          <div 
            key={video.id} 
            className="shrink-0 group bg-white border border-slate-200/60 rounded-3xl overflow-hidden shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_8px_30px_rgb(13,148,136,0.1)] transition-all duration-300 hover:-translate-y-1 cursor-pointer flex flex-col"
            onClick={() => {
              const seconds = parseInt(video.duration) * 60 || 45; 
              setTimeLeft(seconds);
              setIsVideoFinished(false);
              setSelectedVideo(video);
              setStep('player');
            }}
          >
            <div className="h-40 bg-gradient-to-br from-slate-100 to-slate-200 relative flex items-center justify-center overflow-hidden">
              <div className="absolute inset-0 bg-teal-900/5 group-hover:bg-teal-900/0 transition-colors z-10"></div>
              {video.videoUrl ? (
                <div className="absolute inset-0 bg-slate-900/20 flex items-center justify-center z-20 backdrop-blur-[2px] group-hover:backdrop-blur-none transition-all">
                  <PlayCircle size={56} className="text-white drop-shadow-md transform group-hover:scale-110 transition-transform duration-300" />
                </div>
              ) : (
                <PlayCircle size={56} className="text-slate-300 transform group-hover:scale-110 group-hover:text-teal-400 transition-all duration-300 z-20" />
              )}
              <div className="absolute bottom-3 right-3 bg-slate-900/70 backdrop-blur-md text-white text-xs font-bold px-3 py-1.5 rounded-lg z-20">
                {lang === 'tr' ? video.duration : video.durationEn}
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-extrabold text-slate-800 text-lg group-hover:text-teal-700 transition-colors line-clamp-1">{lang === 'tr' ? video.title : video.titleEn}</h3>
              <p className="text-slate-500 text-sm mt-1.5 font-medium line-clamp-2 leading-relaxed">{lang === 'tr' ? video.description : video.descriptionEn}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderPlayer = () => (
    <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 pb-12 bg-slate-50/50">
      <button onClick={() => setStep(isAiMode ? 'ai-results' : 'videos')} className="shrink-0 text-slate-500 mb-6 flex items-center hover:text-teal-600 font-semibold transition-colors w-fit bg-white px-4 py-2 rounded-xl shadow-sm border border-slate-200/60">
        <ArrowLeft size={18} className="mr-2"/> {t[lang].back}
      </button>
      
      <h2 className="shrink-0 text-2xl sm:text-3xl font-extrabold text-slate-800 mb-6 leading-tight">{lang === 'tr' ? selectedVideo.title : selectedVideo.titleEn}</h2>
      
      <div className="shrink-0 w-full aspect-video bg-slate-900 rounded-[2rem] overflow-hidden shadow-2xl mb-6 relative border-4 border-white">
        {selectedVideo.videoUrl ? (
          <iframe 
            className="w-full h-full"
            src={selectedVideo.videoUrl} 
            title={selectedVideo.title}
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-white bg-gradient-to-br from-slate-800 to-slate-900">
             <PlayCircle size={64} className="text-teal-400/50 mb-3" />
             <span className="text-sm font-medium text-slate-400 bg-slate-800/50 px-4 py-2 rounded-full">{t[lang].vidNotLoaded}</span>
          </div>
        )}
      </div>

      <div className="shrink-0 bg-white border border-blue-100/60 p-5 rounded-3xl flex items-start mb-6 shadow-[0_8px_30px_rgb(59,130,246,0.06)] relative overflow-hidden">
        <div className="absolute top-0 left-0 w-1.5 h-full bg-blue-400"></div>
        <Lightbulb size={24} className="text-blue-500 mr-4 flex-shrink-0 mt-1" />
        <div>
          <p className="text-[11px] font-extrabold text-blue-500 uppercase tracking-widest mb-1.5">{t[lang].didYouKnow}</p>
          <p className="text-sm text-slate-600 font-medium leading-relaxed">
            {healthFacts[currentFactIndex][lang]}
          </p>
        </div>
      </div>

      <button 
        onClick={handleCompleteExercise}
        disabled={loading || !isVideoFinished}
        className={`shrink-0 w-full font-bold py-4.5 rounded-2xl transition-all text-lg flex justify-center items-center shadow-lg mb-4 mt-2 ${
          !isVideoFinished 
            ? 'bg-slate-200 text-slate-400 shadow-none cursor-not-allowed border border-slate-300/50'
            : loading 
              ? 'bg-gradient-to-r from-teal-500 to-emerald-500 text-white opacity-70' 
              : 'bg-gradient-to-r from-teal-500 to-emerald-500 text-white hover:from-teal-600 hover:to-emerald-600 shadow-teal-500/30 hover:shadow-teal-500/50 active:scale-95'
        }`}
        style={{ minHeight: '60px' }}
      >
        {!isVideoFinished ? (
          <><Clock size={20} className="mr-2 opacity-60"/> {t[lang].pleaseWait} <span className="ml-2 font-mono bg-slate-300/50 px-2 py-0.5 rounded-md text-slate-500">{timeLeft}{t[lang].sec}</span></>
        ) : loading ? (
          t[lang].saving
        ) : (
          <>{t[lang].completeBtn} <Check className="ml-2" size={24} /></>
        )}
      </button>
    </div>
  );

  const renderSuccess = () => {
    const shareText = t[lang].shareTextPrefix + sessionResult.pointsEarned + t[lang].shareTextSuffix;
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`;

    return (
      <div className="flex flex-col items-center justify-center min-h-full text-center animate-fade-in p-6 sm:p-8 bg-white relative pb-10">
        <CustomConfetti />

        <div className="w-28 h-28 bg-gradient-to-br from-emerald-400 to-teal-500 text-white rounded-[2rem] flex items-center justify-center mb-6 shadow-2xl shadow-emerald-500/30 transform rotate-3 z-10 shrink-0">
          <CheckCircle size={64} className="-rotate-3" />
        </div>
        <h2 className="shrink-0 text-4xl font-extrabold text-slate-800 mb-3 z-10">{t[lang].congrats}</h2>
        <p className="shrink-0 text-slate-500 text-lg font-medium mb-8 z-10">{t[lang].healthStep}</p>

        {sessionResult.pointsEarned === 0 ? (
          <div className="bg-amber-50 text-amber-800 p-4 rounded-2xl text-sm font-bold mb-8 z-10 shadow-sm border border-amber-200/60 w-full flex items-center justify-center shrink-0">
             <Info size={18} className="mr-2"/> {t[lang].dailyLimit}
          </div>
        ) : (
          <div className="w-full bg-white p-6 rounded-3xl mb-8 z-10 shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-slate-100 shrink-0">
            <div className="flex flex-col items-center justify-center text-slate-800 font-extrabold text-2xl mb-4">
               <div className="bg-amber-100 p-3 rounded-full mb-3 shadow-inner">
                 <Star className="text-amber-500 fill-current" size={32} /> 
               </div>
               +{sessionResult.pointsEarned} <span className="text-lg text-slate-500 ml-2">{t[lang].earnedPoints}</span>
            </div>
            
            {sessionResult.newBadges.length > 0 && (
              <div className="mt-5 pt-5 border-t border-slate-100">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">{t[lang].newBadgeUnlocked}</p>
                <div className="flex justify-center flex-wrap gap-3">
                  {sessionResult.newBadges.map(bId => (
                    <div key={bId} className="flex flex-col items-center bg-slate-50 p-3 px-4 rounded-2xl border border-slate-200/60 shadow-sm animate-[bounce_2s_infinite]">
                      <span className="text-3xl mb-2 drop-shadow-sm">{badgeLibrary[bId].icon}</span>
                      <span className="text-[11px] font-extrabold text-slate-700">{badgeLibrary[bId][lang]}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {sessionResult.pointsEarned > 0 && (
          <a 
            href={whatsappUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-full bg-[#25D366] text-white font-bold py-4 rounded-2xl shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 transition-all active:scale-95 text-lg z-10 flex justify-center items-center mb-4 shrink-0"
          >
            <MessageCircle className="mr-2" size={24} /> {t[lang].challengeBtn}
          </a>
        )}

        <button 
          onClick={() => setStep(isAiMode ? 'mode-selection' : 'body-part')}
          className="w-full bg-slate-100 text-slate-700 font-bold py-4 rounded-2xl shadow-sm hover:bg-slate-200 transition-colors active:scale-95 text-lg z-10 shrink-0"
        >
          {t[lang].goHome}
        </button>
      </div>
    );
  };

  const renderProfileModal = () => (
    <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md flex flex-col items-center justify-center p-6 z-50 animate-fade-in">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] shadow-2xl p-6 sm:p-8 relative flex flex-col">
        <button onClick={() => setShowProfileModal(false)} className="absolute top-5 right-5 text-slate-400 hover:text-slate-700 transition-colors bg-slate-50 p-2 rounded-full">
          <X size={20} />
        </button>
        
        <h2 className="text-2xl font-extrabold text-slate-800 mb-8 flex items-center">
          <Award className="text-teal-500 mr-2" size={28}/> {t[lang].profileInfo}
        </h2>
        
        <div className="w-full grid grid-cols-2 gap-4 mb-8">
          <div className="bg-gradient-to-br from-amber-400 to-amber-500 p-5 rounded-3xl text-white shadow-lg shadow-amber-500/30 flex flex-col items-center relative overflow-hidden">
            <div className="absolute -right-4 -bottom-4 opacity-20"><Star size={64} className="fill-current"/></div>
            <Star className="mb-2 fill-current drop-shadow-md" size={32} />
            <p className="text-[11px] font-bold uppercase tracking-wider opacity-90 mb-1">{t[lang].totalPoints}</p>
            <p className="text-4xl font-black drop-shadow-md">{sessionData.totalPoints || 0}</p>
          </div>
          <div className="bg-gradient-to-br from-orange-400 to-rose-500 p-5 rounded-3xl text-white shadow-lg shadow-orange-500/30 flex flex-col items-center relative overflow-hidden">
            <div className="absolute -right-4 -bottom-4 opacity-20"><Flame size={64} className="fill-current"/></div>
            <Flame className="mb-2 fill-current drop-shadow-md" size={32} />
            <p className="text-[11px] font-bold uppercase tracking-wider opacity-90 mb-1">{t[lang].currentStreak}</p>
            <p className="text-4xl font-black drop-shadow-md">{sessionData.currentStreak || 0} <span className="text-sm font-bold opacity-80">{t[lang].dayStreak}</span></p>
          </div>
        </div>

        <div className="w-full bg-slate-50 border border-slate-100 p-5 rounded-3xl">
          <h3 className="font-bold text-slate-700 mb-4 text-sm uppercase tracking-wider">{t[lang].badges}</h3>
          <div className="grid grid-cols-3 gap-3">
            {Object.keys(badgeLibrary).map(bId => {
              const isUnlocked = sessionData.earnedBadges.includes(bId);
              return (
                <div key={bId} className={`flex flex-col items-center justify-center p-3 rounded-2xl text-center transition-all ${isUnlocked ? 'bg-white border border-teal-200 shadow-sm shadow-teal-100' : 'bg-slate-100 border border-transparent opacity-60 grayscale'}`}>
                  <span className="text-3xl mb-2 drop-shadow-sm">{badgeLibrary[bId].icon}</span>
                  <span className="text-[10px] font-extrabold text-slate-700 leading-tight">{badgeLibrary[bId][lang]}</span>
                  {!isUnlocked && <Lock size={12} className="text-slate-400 mt-1.5" />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );

  const renderLeaderboardModal = () => (
    <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md flex flex-col items-center justify-center p-4 sm:p-6 z-50 animate-fade-in">
      <div className="bg-white w-full max-w-md rounded-[2.5rem] shadow-2xl overflow-hidden relative flex flex-col h-[80%] max-h-[650px]">
        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 p-6 sm:p-8 text-white shrink-0 relative">
          <button onClick={() => setShowLeaderboardModal(false)} className="absolute top-5 right-5 text-white/70 hover:text-white transition-colors bg-white/10 p-2 rounded-full backdrop-blur-sm">
            <X size={20} />
          </button>
          <h2 className="text-2xl sm:text-3xl font-extrabold flex items-center mb-2 drop-shadow-md">
            <Trophy className="mr-3 fill-current text-amber-300 drop-shadow-sm" size={32}/> {t[lang].leaderboardTitle}
          </h2>
          <p className="text-indigo-100 text-sm font-medium">{t[lang].leaderboardSub}</p>
        </div>

        <div className="flex-grow overflow-y-auto p-5 sm:p-6 bg-slate-50/50 space-y-3">
          {leaderboardLoading ? (
            <div className="flex items-center justify-center h-full text-indigo-500 font-bold animate-pulse">{t[lang].loadingData}</div>
          ) : (
            leaderboardUsers.map((user, index) => {
              const isMe = user.id === sessionData.userDocId || user.alias === sessionData.alias;
              return (
                <div key={index} className={`w-full flex items-center justify-between p-4 border rounded-2xl shadow-sm text-left relative overflow-hidden transition-all ${
                  isMe ? 'border-indigo-400 bg-indigo-50/80 shadow-indigo-100 scale-[1.02] z-10 ring-2 ring-indigo-500/20' : 
                  index === 0 ? 'border-amber-300 bg-gradient-to-r from-amber-50/50 to-white shadow-amber-100/50' : 
                  index === 1 ? 'border-slate-300 bg-gradient-to-r from-slate-50 to-white shadow-slate-200/50' : 
                  index === 2 ? 'border-orange-300 bg-gradient-to-r from-orange-50/50 to-white shadow-orange-100/50' : 
                  'border-slate-200/60 bg-white hover:border-slate-300'
                }`}>
                  {isMe && <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-indigo-500 shadow-[0_0_10px_rgba(99,102,241,0.5)]"></div>}
                  <div className="flex items-center space-x-4">
                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center font-black text-lg shadow-inner shrink-0 ${
                      index === 0 ? 'bg-gradient-to-br from-amber-300 to-amber-500 text-white' : 
                      index === 1 ? 'bg-gradient-to-br from-slate-300 to-slate-400 text-white' : 
                      index === 2 ? 'bg-gradient-to-br from-orange-300 to-orange-500 text-white' : 
                      'bg-slate-100 text-slate-500'
                    }`}>
                      {index + 1}
                    </div>
                    <div>
                      <h3 className={`font-extrabold text-base sm:text-lg flex items-center ${isMe ? 'text-indigo-700' : 'text-slate-800'}`}>
                        {user.alias}
                        {isMe && <span className="ml-2 bg-gradient-to-r from-indigo-500 to-purple-500 text-white text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-md shadow-sm">{t[lang].you}</span>}
                      </h3>
                      <div className="flex space-x-1 mt-1">
                        {(user.earnedBadges || []).slice(0, 4).map(bId => badgeLibrary[bId] && <span key={bId} className="text-[14px] drop-shadow-sm">{badgeLibrary[bId].icon}</span>)}
                        {(user.earnedBadges || []).length > 4 && <span className="text-[11px] text-slate-400 font-bold flex items-center ml-1">+{user.earnedBadges.length - 4}</span>}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className={`font-black text-2xl ${isMe ? 'text-indigo-700' : 'text-slate-800'}`}>{user.totalPoints || 0}</p>
                    <p className="text-[9px] font-extrabold text-slate-400 uppercase tracking-widest mt-0.5">{t[lang].points}</p>
                  </div>
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  );

  const renderStationDetail = () => {
    const sihhiyeCodes = ['30010', '30011', '30012', '30013', '30014', 'sihhiye_metro'];
    const hacettepeCodes = ['30056', '30020', '30016', 'hacettepe_hastane'];

    const stationName = selectedStationId === 'sihhiye' ? 'Sıhhiye Metro Durağı' : 'Hacettepe Hastane Durağı';
    const sessions = selectedStationId === 'sihhiye' 
      ? adminSessions.filter(s => sihhiyeCodes.includes(s.locationId)) 
      : adminSessions.filter(s => hacettepeCodes.includes(s.locationId));
    
    const totalCount = sessions.length;
    
    const topAreaKey = getMostFrequent(sessions.map(s => s.selectedArea).filter(Boolean));
    const topArea = topAreaKey !== 'NO_DATA' ? (areaTranslations[topAreaKey]?.[lang] || topAreaKey) : t[lang].noData;
    
    const topExKey = getMostFrequent(sessions.map(s => s.completedExerciseTitle).filter(Boolean));
    const topEx = topExKey !== 'NO_DATA' ? topExKey : t[lang].noData;

    return (
      <div className="flex-grow animate-fade-in space-y-5 pb-6">
        <button onClick={() => setSelectedStationId(null)} className="shrink-0 text-slate-500 mb-2 flex items-center hover:text-teal-600 font-semibold transition-colors bg-white px-3 py-1.5 rounded-xl border border-slate-200 shadow-sm w-fit">
          <ArrowLeft size={18} className="mr-1"/> {t[lang].mapReturn}
        </button>
        
        <h3 className="shrink-0 text-2xl font-black text-slate-800 mb-2">{stationName}</h3>
        <p className="shrink-0 text-slate-500 font-medium mb-4 text-sm">{t[lang].stationStats}</p>

        <div className="shrink-0 bg-white border border-slate-200/60 p-5 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
              <Activity size={16} className="mr-2 text-blue-500" /> {t[lang].totalEntry}
            </div>
            <p className="text-4xl font-black text-slate-800">{totalCount} <span className="text-base font-bold text-slate-400">{t[lang].personSession}</span></p>
        </div>

        <div className="shrink-0 bg-white border border-slate-200/60 p-5 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
              <HeartPulse size={16} className="mr-2 text-rose-500" /> {t[lang].mostSelectedArea}
            </div>
            <p className="text-2xl font-black text-slate-800">{topArea}</p>
        </div>

        <div className="shrink-0 bg-white border border-slate-200/60 p-5 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
              <TrendingUp size={16} className="mr-2 text-indigo-500" /> {t[lang].favEx}
            </div>
            <p className="text-xl font-black text-slate-800 leading-tight">{topEx}</p>
        </div>
      </div>
    );
  };

  const renderAdminHeatmap = () => {
    if (selectedStationId) {
      return renderStationDetail();
    }

    const sihhiyeCodes = ['30010', '30011', '30012', '30013', '30014', 'sihhiye_metro'];
    const hacettepeCodes = ['30056', '30020', '30016', 'hacettepe_hastane'];

    const sihhiyeSessions = adminSessions.filter(s => sihhiyeCodes.includes(s.locationId));
    const hacettepeSessions = adminSessions.filter(s => hacettepeCodes.includes(s.locationId));

    const sihhiyeCount = sihhiyeSessions.length;
    const hacettepeCount = hacettepeSessions.length;

    let kiyaslamaText = { tr: "Henüz yeterli veri toplanmadı. Duraklarda etkileşim bekleniyor.", en: "Not enough data collected yet. Awaiting interaction at stations." };
    let verimlilikText = { tr: "Sistem yeni aktif edildi, okutma verileri analiz ediliyor.", en: "System recently activated, scan data is being analyzed." };
    let oneriText = { tr: "Veri havuzu oluştukça belediye için stratejik altyapı önerileri sunulacaktır.", en: "Strategic infrastructure proposals for the city will be presented as the data pool grows." };

    if (adminSessions.length > 0) {
      const sihhiyeTopAreaKey = getMostFrequent(sihhiyeSessions.map(s => s.selectedArea).filter(Boolean));
      const hacettepeTopAreaKey = getMostFrequent(hacettepeSessions.map(s => s.selectedArea).filter(Boolean));
      
      const sihTr = sihhiyeTopAreaKey !== 'NO_DATA' ? areaTranslations[sihhiyeTopAreaKey]?.tr : t.tr.noData;
      const sihEn = sihhiyeTopAreaKey !== 'NO_DATA' ? areaTranslations[sihhiyeTopAreaKey]?.en : t.en.noData;
      const hacTr = hacettepeTopAreaKey !== 'NO_DATA' ? areaTranslations[hacettepeTopAreaKey]?.tr : t.tr.noData;
      const hacEn = hacettepeTopAreaKey !== 'NO_DATA' ? areaTranslations[hacettepeTopAreaKey]?.en : t.en.noData;

      if (sihhiyeCount > 0 && hacettepeCount > 0) {
          kiyaslamaText = {
              tr: `Sıhhiye durağında kullanıcılar en çok '${sihTr}' şikayetiyle işlem yaparken; Hacettepe durağında daha çok '${hacTr}' odaklı egzersizler tercih edilmektedir.`,
              en: `Users at Sıhhiye station mostly engage with '${sihEn}' complaints, whereas '${hacEn}' focused exercises are more preferred at Hacettepe station.`
          };
          
          if (sihhiyeCount > hacettepeCount) {
              const oran = (sihhiyeCount / hacettepeCount).toFixed(1);
              verimlilikText = {
                  tr: `Sıhhiye Metro QR kodları, Hacettepe'ye göre ${oran} kat daha fazla etkileşim aldı. Bu bölgedeki yaya trafiği sağlık platformuna daha fazla entegre oluyor.`,
                  en: `Sıhhiye Metro QR codes received ${oran} times more interaction compared to Hacettepe. Pedestrian traffic in this area integrates more into the platform.`
              };
          } else if (hacettepeCount > sihhiyeCount) {
              const oran = (hacettepeCount / sihhiyeCount).toFixed(1);
              verimlilikText = {
                  tr: `Hacettepe Hastane QR kodları, Sıhhiye'ye göre ${oran} kat daha fazla etkileşim aldı. Muhtemelen hastane çevresindeki bekleme süreleri daha uzun.`,
                  en: `Hacettepe Hospital QR codes received ${oran} times more interaction compared to Sıhhiye. Wait times around the hospital are likely longer.`
              };
          } else {
              verimlilikText = {
                  tr: "Her iki durakta da eşit seviyede yüksek verimlilikle egzersiz yapılmaktadır. Duraklar arası etkileşim dengeli dağılıyor.",
                  en: "Exercises are performed with an equally high level of efficiency at both stations. Interaction is balanced."
              };
          }
      } else if (sihhiyeCount > 0) {
          kiyaslamaText = {
              tr: `Şu an sistemde ağırlıklı olarak Sıhhiye durağı aktiftir (En sık yaşanan ağrı: ${sihTr}). Hacettepe verileri karşılaştırma için bekleniyor.`,
              en: `Currently, the Sıhhiye station is mainly active in the system (Most frequent pain: ${sihEn}). Awaiting Hacettepe data for comparison.`
          };
          verimlilikText = {
              tr: `Sıhhiye Metro durağı toplam ${sihhiyeCount} seans ile yüksek verimlilikte çalışmaktadır.`,
              en: `Sıhhiye Metro station is operating at high efficiency with a total of ${sihhiyeCount} sessions.`
          };
      } else if (hacettepeCount > 0) {
          kiyaslamaText = {
              tr: `Şu an sistemde ağırlıklı olarak Hacettepe durağı aktiftir (En sık yaşanan ağrı: ${hacTr}). Sıhhiye verileri karşılaştırma için bekleniyor.`,
              en: `Currently, the Hacettepe station is mainly active in the system (Most frequent pain: ${hacEn}). Awaiting Sıhhiye data for comparison.`
          };
          verimlilikText = {
              tr: `Hacettepe durağı toplam ${hacettepeCount} seans ile yüksek verimlilikte çalışmaktadır.`,
              en: `Hacettepe station is operating at high efficiency with a total of ${hacettepeCount} sessions.`
          };
      }

      const allAreas = adminSessions.map(s => s.selectedArea).filter(Boolean);
      const globalTopAreaKey = getMostFrequent(allAreas);
      
      if (globalTopAreaKey === 'Bel' || globalTopAreaKey === 'Omuz ve Sırt') {
           oneriText = {
               tr: `Tüm duraklar baz alındığında genel istatistiklerde '${areaTranslations[globalTopAreaKey].tr}' şikayetleri zirvededir. Bu veriye dayanarak, bölgedeki otobüs durak banklarının daha ergonomik ve bel destekli modellerle yenilenmesi halk sağlığı için stratejik bir fayda sağlayacaktır.`,
               en: `Based on all stations, '${areaTranslations[globalTopAreaKey].en}' complaints are at their peak. Renewing bus stop benches with ergonomic models will provide a strategic benefit for public health.`
           };
      } else if (globalTopAreaKey === 'Bacak ve Diz') {
           oneriText = {
               tr: `Sistem kullancılarının en büyük şikayeti '${areaTranslations[globalTopAreaKey].tr}' bölgesindedir. Bekleme alanlarında uzun süre ayakta kalmayı önleyecek, yaşlı/hasta kullanımına uygun ek oturma birimleri planlanmalıdır.`,
               en: `The main complaint is in the '${areaTranslations[globalTopAreaKey].en}' area. Additional seating units suitable for the elderly/sick should be planned in waiting areas.`
           };
      } else if (globalTopAreaKey !== 'NO_DATA') {
           oneriText = {
               tr: `Bölge halkında yoğunlukla '${areaTranslations[globalTopAreaKey].tr}' yorgunluğu gözlemlenmektedir. İlgili duraklardaki dijital veya raket panolara, duruş bozukluğunu engelleyici bilgilendirme afişleri asılması önerilir.`,
               en: `Intense '${areaTranslations[globalTopAreaKey].en}' fatigue is observed in the region. It is recommended to hang informative posters preventing bad posture on digital boards.`
           };
      }
    }

    return (
      <div className="flex-grow space-y-5 pb-6">
        <div className="shrink-0 bg-gradient-to-br from-indigo-900 to-slate-900 rounded-3xl p-6 text-white shadow-lg relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-teal-500/20 rounded-full blur-2xl"></div>
          
          <h3 className="text-xl font-extrabold flex items-center mb-4 text-indigo-100 z-10 relative">
             <BrainCircuit className="mr-2 text-indigo-400" /> {t[lang].aiReport}
          </h3>
          
          <div className="space-y-4 z-10 relative">
            <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl border border-white/10">
              <div className="flex items-center text-teal-300 text-xs font-bold uppercase tracking-wider mb-2">
                <BarChart3 size={14} className="mr-1.5" /> {t[lang].comparison}
              </div>
              <p className="text-sm font-medium leading-relaxed">
                "{kiyaslamaText[lang]}"
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl border border-white/10">
              <div className="flex items-center text-amber-300 text-xs font-bold uppercase tracking-wider mb-2">
                <TrendingUp size={14} className="mr-1.5" /> {t[lang].efficiency}
              </div>
              <p className="text-sm font-medium leading-relaxed">
                "{verimlilikText[lang]}"
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl border border-white/10">
              <div className="flex items-center text-rose-300 text-xs font-bold uppercase tracking-wider mb-2">
                <Map size={14} className="mr-1.5" /> {t[lang].cityProposal}
              </div>
              <p className="text-sm font-medium leading-relaxed">
                "{oneriText[lang]}"
              </p>
            </div>
          </div>
        </div>

        <h3 className="shrink-0 font-bold text-slate-700 mt-6 mb-2 text-sm uppercase tracking-wider px-1 flex items-center">
          <MapPin size={16} className="mr-2 text-rose-500" /> {t[lang].pilotData}
        </h3>

        <div className="shrink-0 bg-white border border-indigo-100 p-6 rounded-3xl mb-6 shadow-sm relative overflow-hidden">
            <div className="absolute -right-10 -bottom-10 opacity-5 pointer-events-none">
                <BrainCircuit size={150} />
            </div>
            <h3 className="font-extrabold text-indigo-900 mb-2 flex items-center">
                <BrainCircuit className="mr-2 text-indigo-500"/>
                {lang === 'tr' ? 'Gemini AI Derin Analiz' : 'Gemini AI Deep Analysis'}
            </h3>
            <p className="text-sm text-slate-500 mb-4 font-medium relative z-10">
                {lang === 'tr'
                    ? 'Tüm durak verilerini harmanlayarak stratejik halk sağlığı raporu oluşturun.'
                    : 'Generate a strategic public health report by blending all station data.'}
            </p>

            {!adminAiInsight && !isGeneratingInsight && (
                <button
                    onClick={generateAdminInsight}
                    className="bg-indigo-50 text-indigo-600 font-bold py-2.5 px-5 rounded-xl border border-indigo-200 hover:bg-indigo-100 transition-colors w-full sm:w-auto flex items-center justify-center shadow-sm relative z-10 active:scale-95"
                >
                    <BrainCircuit size={18} className="mr-2"/> {lang === 'tr' ? 'Rapor Üret' : 'Generate Report'}
                </button>
            )}

            {isGeneratingInsight && (
                <div className="flex items-center text-indigo-500 font-bold animate-pulse text-sm py-2">
                    <BrainCircuit size={20} className="mr-2 animate-spin" />
                    {lang === 'tr' ? 'Yapay Zeka Analiz Ediyor...' : 'AI is Analyzing...'}
                </div>
            )}

            {adminAiInsight && !isGeneratingInsight && (
                <div className="bg-indigo-50/60 p-5 rounded-2xl border border-indigo-200/60 text-sm text-slate-700 font-medium leading-relaxed whitespace-pre-wrap shadow-inner relative z-10">
                    {adminAiInsight}
                </div>
            )}
        </div>

        <div className="grid grid-cols-1 gap-4 pb-6">
          <div 
            onClick={() => setSelectedStationId('sihhiye')}
            className="shrink-0 bg-white border-2 border-rose-100 p-5 rounded-3xl shadow-sm relative overflow-hidden group hover:border-rose-300 transition-all cursor-pointer hover:shadow-md hover:-translate-y-1"
          >
            <div className="absolute right-[-10px] top-[-10px] bg-rose-50 w-24 h-24 rounded-full flex items-center justify-center opacity-50 group-hover:scale-110 transition-transform">
              <MapPin size={48} className="text-rose-200" />
            </div>
            <h4 className="font-extrabold text-xl text-slate-800 mb-1 group-hover:text-rose-600 transition-colors">Sıhhiye Metro Durağı</h4>
            <div className="flex flex-wrap gap-1.5 mb-4 mt-2">
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30010</span>
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30011</span>
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30012</span>
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30013</span>
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30014</span>
            </div>
            <div className="flex items-center text-rose-600 font-black text-2xl relative z-10">
              {sihhiyeCount > 0 ? sihhiyeCount : '0'} <span className="text-sm font-bold text-slate-400 ml-2 group-hover:text-rose-400">{t[lang].viewAnalytics} <ChevronRight size={16} className="inline ml-1"/></span>
            </div>
          </div>

          <div 
            onClick={() => setSelectedStationId('hacettepe')}
            className="shrink-0 bg-white border-2 border-blue-100 p-5 rounded-3xl shadow-sm relative overflow-hidden group hover:border-blue-300 transition-all cursor-pointer hover:shadow-md hover:-translate-y-1"
          >
            <div className="absolute right-[-10px] top-[-10px] bg-blue-50 w-24 h-24 rounded-full flex items-center justify-center opacity-50 group-hover:scale-110 transition-transform">
              <MapPin size={48} className="text-blue-200" />
            </div>
            <h4 className="font-extrabold text-xl text-slate-800 mb-1 group-hover:text-blue-600 transition-colors">Hacettepe Hastane Durağı</h4>
            <div className="flex flex-wrap gap-1.5 mb-4 mt-2">
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30056</span>
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30020</span>
              <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-md">30016</span>
            </div>
            <div className="flex items-center text-blue-600 font-black text-2xl relative z-10">
              {hacettepeCount > 0 ? hacettepeCount : '0'} <span className="text-sm font-bold text-slate-400 ml-2 group-hover:text-blue-400">{t[lang].viewAnalytics} <ChevronRight size={16} className="inline ml-1"/></span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderAdminList = () => {
    const leaderboardUsers = [...adminUsers].sort((a, b) => (b.totalPoints || 0) - (a.totalPoints || 0));

    return (
      <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-slate-50/50">
        <div className="shrink-0 flex items-center justify-between mb-8">
          <button onClick={handleGoHome} className="text-slate-500 flex items-center hover:text-teal-600 font-semibold transition-colors bg-white px-3 py-1.5 rounded-xl border border-slate-200 shadow-sm">
            <ArrowLeft size={18} className="mr-1"/> {t[lang].exit}
          </button>
          
          <div className="flex bg-white rounded-xl p-1 shadow-sm border border-slate-200 overflow-x-auto hide-scrollbar">
            <button onClick={() => { setAdminTab('list'); setSelectedStationId(null); }} className={`px-3 py-1.5 text-xs sm:text-sm font-bold rounded-lg transition-colors whitespace-nowrap ${adminTab === 'list' ? 'bg-slate-800 text-white shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>{t[lang].clientsTab}</button>
            <button onClick={() => { setAdminTab('leaderboard'); setSelectedStationId(null); }} className={`px-3 py-1.5 text-xs sm:text-sm font-bold rounded-lg transition-colors whitespace-nowrap ${adminTab === 'leaderboard' ? 'bg-amber-500 text-white shadow-sm' : 'text-slate-500 hover:text-amber-600'}`}>{t[lang].leaderboardTab}</button>
            <button onClick={() => setAdminTab('heatmap')} className={`px-3 py-1.5 text-xs sm:text-sm font-bold rounded-lg transition-colors whitespace-nowrap flex items-center ${adminTab === 'heatmap' ? 'bg-rose-500 text-white shadow-sm' : 'text-slate-500 hover:text-rose-600'}`}><Map size={14} className="mr-1"/> {t[lang].heatmapTab}</button>
          </div>
        </div>

        {!selectedStationId && (
          <>
            <h2 className="shrink-0 text-2xl sm:text-3xl font-extrabold text-slate-800 mb-2">
              {adminTab === 'list' ? t[lang].adminPanelTitle : adminTab === 'leaderboard' ? t[lang].leaderboard : t[lang].mapTitle}
            </h2>
            <p className="shrink-0 text-slate-500 font-medium mb-6">
              {adminTab === 'list' ? t[lang].adminPanelSub : adminTab === 'leaderboard' ? t[lang].leaderboardDesc : t[lang].mapSub}
            </p>
          </>
        )}

        {adminTab === 'heatmap' && renderAdminHeatmap()}

        {adminTab === 'list' && (
          <div className="flex flex-col space-y-4 mb-6 shrink-0">
            <button 
              onClick={exportToCSV}
              disabled={adminUsers.length === 0}
              className={`w-full flex items-center justify-center py-4 rounded-2xl font-bold transition-all text-lg ${
                adminUsers.length === 0 ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 active:scale-95'
              }`}
            >
              <Download size={20} className="mr-2" /> {t[lang].downloadExcel}
            </button>
            
            {!showClearConfirm ? (
              <button 
                onClick={() => setShowClearConfirm(true)}
                disabled={adminUsers.length === 0 || isClearing}
                className={`w-full flex items-center justify-center py-3 rounded-2xl font-bold transition-all text-sm border-2 ${
                  adminUsers.length === 0 ? 'border-slate-200 text-slate-400 cursor-not-allowed' : 'border-rose-200 text-rose-500 hover:bg-rose-50 active:scale-95'
                }`}
              >
                <Trash2 size={16} className="mr-2" /> {t[lang].clearDataBtn}
              </button>
            ) : (
              <div className="bg-rose-50 border border-rose-200 rounded-2xl p-4 animate-fade-in text-center">
                <p className="text-rose-700 font-bold text-sm mb-3">{t[lang].confirmClear}</p>
                <div className="flex space-x-3">
                  <button onClick={() => setShowClearConfirm(false)} className="flex-1 bg-white border border-slate-300 text-slate-600 font-bold py-2 rounded-xl hover:bg-slate-50 transition-colors">Vazgeç</button>
                  <button onClick={clearAllFirebaseData} disabled={isClearing} className="flex-1 bg-rose-500 text-white font-bold py-2 rounded-xl hover:bg-rose-600 transition-colors shadow-md shadow-rose-500/20">
                    {isClearing ? t[lang].clearing : "Evet, Temizle"}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {loading && adminTab !== 'heatmap' ? (
          <div className="flex-grow flex items-center justify-center text-teal-600 font-bold animate-pulse">{t[lang].loadingData}</div>
        ) : (
          <div className="flex-grow space-y-4 pb-6">
            
            {adminTab === 'list' && adminUsers.map((user, index) => (
              <button key={index} onClick={() => setSelectedAdminUser(user)} className="shrink-0 w-full flex items-center justify-between p-5 bg-white border border-slate-200/60 rounded-3xl shadow-sm hover:shadow-md hover:border-teal-300 transition-all text-left group">
                <div className="flex items-center space-x-4">
                  <div className="bg-slate-100 text-slate-600 w-14 h-14 rounded-2xl flex items-center justify-center font-black text-xl group-hover:bg-teal-50 group-hover:text-teal-600 transition-colors">
                    {(user.alias || "").split(' ')[1] || 'U'}
                  </div>
                  <div>
                    <h3 className="font-extrabold text-slate-800 text-lg group-hover:text-teal-700 transition-colors">{user.alias}</h3>
                    <p className="text-slate-500 font-medium text-sm mt-0.5">{user.totalSessions > 0 ? `${t[lang].totalEx} ${user.totalSessions}` : t[lang].noExercise}</p>
                  </div>
                </div>
                <div className="bg-slate-50 p-2 rounded-full group-hover:bg-teal-50 transition-colors">
                  <ChevronRight className="text-slate-400 group-hover:text-teal-600" />
                </div>
              </button>
            ))}

            {adminTab === 'leaderboard' && leaderboardUsers.map((user, index) => {
              const isMe = user.id === sessionData.userDocId || user.alias === sessionData.alias;
              return (
                <div key={index} className={`shrink-0 w-full flex items-center justify-between p-5 bg-white border rounded-3xl shadow-sm text-left ${
                  isMe ? 'border-indigo-400 bg-indigo-50/80 shadow-indigo-100 scale-[1.02] z-10 ring-2 ring-indigo-500/20' : 
                  index === 0 ? 'border-amber-300 bg-gradient-to-r from-amber-50/50 to-white shadow-amber-100/50' : 
                  index === 1 ? 'border-slate-300 bg-gradient-to-r from-slate-50 to-white shadow-slate-200/50' : 
                  index === 2 ? 'border-orange-300 bg-gradient-to-r from-orange-50/50 to-white shadow-orange-100/50' : 
                  'border-slate-200/60 bg-white hover:border-slate-300'
                }`}>
                  {isMe && <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-indigo-500 shadow-[0_0_10px_rgba(99,102,241,0.5)]"></div>}
                  <div className="flex items-center space-x-4">
                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center font-black text-lg shadow-inner shrink-0 ${
                      index === 0 ? 'bg-gradient-to-br from-amber-300 to-amber-500 text-white' : 
                      index === 1 ? 'bg-gradient-to-br from-slate-300 to-slate-400 text-white' : 
                      index === 2 ? 'bg-gradient-to-br from-orange-300 to-orange-500 text-white' : 
                      'bg-slate-100 text-slate-500'
                    }`}>
                      {index + 1}
                    </div>
                    <div>
                      <h3 className={`font-extrabold text-base sm:text-lg flex items-center ${isMe ? 'text-indigo-700' : 'text-slate-800'}`}>
                        {user.alias}
                        {isMe && <span className="ml-2 bg-gradient-to-r from-indigo-500 to-purple-500 text-white text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-md shadow-sm">{t[lang].you}</span>}
                      </h3>
                      <div className="flex space-x-1 mt-1">
                        {(user.earnedBadges || []).slice(0, 4).map(bId => badgeLibrary[bId] && <span key={bId} className="text-[14px] drop-shadow-sm">{badgeLibrary[bId].icon}</span>)}
                        {(user.earnedBadges || []).length > 4 && <span className="text-[11px] text-slate-400 font-bold flex items-center ml-1">+{user.earnedBadges.length - 4}</span>}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className={`font-black text-2xl ${isMe ? 'text-indigo-700' : 'text-slate-800'}`}>{user.totalPoints || 0}</p>
                    <p className="text-[9px] font-extrabold text-slate-400 uppercase tracking-widest mt-0.5">{t[lang].points}</p>
                  </div>
                </div>
              );
            })}

            {adminTab !== 'heatmap' && adminUsers.length === 0 && (
              <div className="text-center text-slate-400 mt-10 font-medium">{t[lang].noClients}</div>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderAdminDetail = () => {
    if (!selectedAdminUser) return null;
    const user = selectedAdminUser;

    return (
      <div className="flex flex-col min-h-full animate-fade-in p-6 sm:p-8 bg-slate-50/50">
        <button onClick={() => setSelectedAdminUser(null)} className="shrink-0 text-slate-500 mb-8 flex items-center hover:text-teal-600 font-semibold transition-colors bg-white px-4 py-2 rounded-xl border border-slate-200 shadow-sm w-fit">
          <ArrowLeft size={18} className="mr-2"/> {t[lang].clientList}
        </button>

        <div className="shrink-0 flex items-center space-x-5 mb-8 bg-white p-6 rounded-3xl shadow-sm border border-slate-200/60">
          <div className="bg-gradient-to-br from-slate-700 to-slate-900 text-white w-20 h-20 rounded-2xl flex items-center justify-center shadow-lg shadow-slate-900/20 flex-shrink-0">
            <User size={36} />
          </div>
          <div>
            <h2 className="text-3xl font-extrabold text-slate-800 mb-1">{user.alias}</h2>
            <p className="text-teal-600 font-bold">{user.gender} • {user.age} {t[lang].ageOld}</p>
            <div className="flex flex-wrap gap-2 mt-3">
               {(user.earnedBadges || []).map(bId => (
                 <span key={bId} className="text-sm bg-slate-100 border border-slate-200 rounded-lg px-2 py-1 shadow-sm flex items-center">
                   <span className="mr-1">{badgeLibrary[bId].icon}</span> <span className="text-[10px] font-bold text-slate-600">{badgeLibrary[bId][lang]}</span>
                 </span>
               ))}
            </div>
          </div>
        </div>

        <div className="flex-grow pb-6 space-y-5">
          <div className="grid grid-cols-2 gap-5 shrink-0">
            <div className="bg-white border border-slate-200/60 p-5 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)]">
              <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
                <Activity size={16} className="mr-2 text-blue-500" /> {t[lang].totalEntry}
              </div>
              <p className="text-2xl font-black text-slate-800">{user.totalSessions} <span className="text-base font-bold text-slate-400">{t[lang].times}</span></p>
            </div>
            <div className="bg-white border border-slate-200/60 p-5 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)]">
              <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
                <Calendar size={16} className="mr-2 text-emerald-500" /> {t[lang].lastEx}
              </div>
              <p className="text-sm font-black text-slate-800 break-words mt-1">{user.lastLoginDate}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 shrink-0">
            <div className="bg-white border border-slate-200/60 p-5 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)]">
              <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
                <Star size={16} className="mr-2 text-amber-500 fill-current" /> {t[lang].points}
              </div>
              <p className="text-3xl font-black text-slate-800">{user.totalPoints || 0}</p>
            </div>
            <div className="bg-white border border-slate-200/60 p-5 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)]">
              <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
                <Flame size={16} className="mr-2 text-orange-500 fill-current" /> En İyi Serisi
              </div>
              <p className="text-3xl font-black text-slate-800">{user.currentStreak || 0} <span className="text-base font-bold text-slate-400">{t[lang].days}</span></p>
            </div>
          </div>

          <div className="shrink-0 bg-white border border-slate-200/60 p-5 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)]">
            <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
              <HeartPulse size={16} className="mr-2 text-rose-500" /> {t[lang].favArea}
            </div>
            <p className="text-xl font-black text-slate-800">{user.favoriteArea}</p>
          </div>

          <div className="shrink-0 bg-white border border-slate-200/60 p-5 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.02)]">
            <div className="flex items-center text-slate-500 mb-3 font-bold text-sm uppercase tracking-wider">
              <TrendingUp size={16} className="mr-2 text-indigo-500" /> {t[lang].favEx}
            </div>
            <p className="text-lg font-black text-slate-800 leading-tight">{user.favoriteExercise}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4 sm:p-8 font-sans">
      <div className="w-full max-w-[420px] bg-white h-[85vh] min-h-[680px] rounded-[2.5rem] shadow-2xl overflow-hidden relative flex flex-col ring-1 ring-slate-900/5">
        
        {/* Modern Üst Bar (Glassmorphism) */}
        <div className="bg-white/80 backdrop-blur-md border-b border-slate-100 p-5 flex justify-between items-center z-20 sticky top-0 shrink-0">
          <div 
            className="font-extrabold text-lg flex items-center cursor-pointer hover:opacity-80 transition-opacity text-slate-800"
            onClick={handleGoHome}
            title={t[lang].goHomeTitle}
          >
             <div className="w-9 h-9 rounded-xl overflow-hidden shadow-sm border border-slate-100 mr-2.5">
                <img src="/logo.png" alt="FizyoDurak Logo" className="w-full h-full object-cover bg-white" /> 
             </div>
             FizyoDurak {step === 'admin' && <span className="text-teal-500 ml-1.5 text-sm uppercase tracking-wider bg-teal-50 px-2 py-0.5 rounded-lg">{t[lang].panel}</span>}
          </div>
          
          <div className="flex items-center space-x-2.5">
             {step !== 'welcome' && step !== 'admin' && sessionData.alias && (
                <div className="flex items-center space-x-2">
                  <button 
                    onClick={handleOpenLeaderboard}
                    className="flex items-center justify-center w-9 h-9 bg-indigo-50 text-indigo-600 hover:bg-indigo-100 rounded-xl transition-colors border border-indigo-200/50 shadow-sm"
                    title={t[lang].leaderboardTitle}
                  >
                    <Trophy size={18} className="fill-current" />
                  </button>
                  <button 
                    onClick={() => setShowProfileModal(true)}
                    className="flex items-center text-sm font-bold bg-amber-50 text-amber-600 hover:bg-amber-100 px-3 py-1.5 rounded-xl transition-colors border border-amber-200/50 shadow-sm"
                  >
                    <Star size={16} className="mr-1.5 fill-current" /> {sessionData.totalPoints || 0}
                  </button>
                </div>
             )}

             <button 
               onClick={() => setLang(l => l === 'tr' ? 'en' : 'tr')}
               className="flex items-center text-xs font-bold bg-slate-100 text-slate-600 hover:bg-slate-200 px-2.5 py-2 rounded-xl transition-colors border border-slate-200"
             >
               <Globe size={16} className="mr-1.5" /> {lang === 'tr' ? 'TR' : 'EN'}
             </button>
          </div>
        </div>
        
        {/* ANA İÇERİK KAPSAYICI */}
        <div className="flex-grow flex flex-col overflow-y-auto relative bg-white scroll-smooth">
          {step === 'welcome' && renderWelcome()}
          {step === 'demographics' && renderDemographics()}
          {step === 'mode-selection' && renderModeSelection()}
          {step === 'ai-questions' && renderAIQuestions()}
          {step === 'ai-loading' && renderAILoading()}
          {step === 'ai-results' && renderAIResults()}
          {step === 'body-part' && renderBodyPartSelection()}
          {step === 'videos' && renderVideos()}
          {step === 'player' && renderPlayer()}
          {step === 'success' && renderSuccess()}
          
          {step === 'medical-warnings' && renderMedicalWarnings()}
          {step === 'terms-of-use' && renderTermsOfUse()}
          {step === 'privacy-policy' && renderPrivacyPolicy()}
          {step === 'admin' && (selectedAdminUser ? renderAdminDetail() : renderAdminList())}
          
          {showProfileModal && renderProfileModal()}
          {showLeaderboardModal && renderLeaderboardModal()}
        </div>
      </div>
    </div>
  );
}